module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "ch002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-002"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch-002"
    }
  }, [_vm._v("Psalm 90: The Voice of Chastened Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "H1a",
    attrs: {
      "id": "s001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OICE OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMIST")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "verse1a"
  }, [_vm._v("1"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("A prayer by Moses, the man of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("O Lord, you have been a dwelling place"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" for us")]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("throughout generations.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("2"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("Before the mountains were born,")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("and you brought to birth the earth and the world,")]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("from eternity to eternity you are God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("3"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("You return"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")])]), _vm._v(" the mortal to dust;")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("you say: “Return humankind.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("4"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("Surely, a thousand years in your estimation")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("is like yesterday when it is over,")]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("and like a watch in the night.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("5"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("You make an end of their lives;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])]), _vm._v(" they fall into deep sleep"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])]), _vm._v(";")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("in the morning they are like grass that is renewed."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("6"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("In the morning it blossoms and is renewed;")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("in the evening, it withers and dries up.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("7"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("Surely, we perish in your anger;")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("we are terrified by your wrath.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("8"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("You set our iniquities before you,")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("our hidden sins in the light of your face.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("9"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("All our days pass away in your fierce anger;")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("we finish our years like a sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("10"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("As for the days of our years, with them are seventy years;")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("or if with strength,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" eighty years.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("And their proud achievements"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" are toilsome and futile,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("for they pass away"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" quickly,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" and we fly away.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("11"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Who knows the vehemence of your anger,")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("and, according to the fear due you,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" your fierce anger?")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("12"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("In numbering our days, so"), _c('sup')])]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(" cause [us] to know [your anger]")]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("that"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" we may gain wise hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("13"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Turn back,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('i', [_vm._v("I AM")]), _vm._v("! How long?")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("And take pity"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")])]), _vm._v(" on"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" your servants.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("14"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Satisfy us in the morning with your unfailing love")])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "verse1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("that"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(" we may shout for joy and rejoice in all our days.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("15"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Make us rejoice according to the days you afflicted us,")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("[according to] the years we saw disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("16"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Let your deeds"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19",
      "id": "fn19"
    }
  }, [_vm._v("19")])]), _vm._v(" appear"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20",
      "id": "fn20"
    }
  }, [_vm._v("20")])]), _vm._v(" to your servants")])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_vm._v("and your splendor"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21",
      "id": "fn21"
    }
  }, [_vm._v("21")])]), _vm._v(" to"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22",
      "id": "fn22"
    }
  }, [_vm._v("22")])]), _vm._v(" their children.")]), _vm._v(" "), _c('p', {
    staticClass: "verse1n"
  }, [_vm._v("17"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Let the beauty of the Lord our God rest upon us,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23",
      "id": "fn23"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "verse1"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("and the work of our hands establish for us;")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "verse1"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("and the work of our hands, establish it."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24",
      "id": "fn24"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "H1b",
    attrs: {
      "id": "s002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")])])]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s3"
    }
  }, [_vm._v("I. Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Form")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Psalm 90 is poetry, characterized by parallelism, terseness—poets do not footnote exceptions—and figurative language (see p. 23). Its stated specific form is “a prayer.” This “chastened and sober”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25",
      "id": "fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" prayer contains the five typical motifs of a lament/petition psalm:")]), _vm._v(" "), _c('p', {
    staticClass: "Li-U1"
  }, [_c('span', {
    staticClass: "space055"
  }, [_vm._v("I."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Direct address: “O Lord,” v. 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "Li-U"
  }, [_c('span', {
    staticClass: "space025"
  }, [_vm._v("II."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Confidence: “a dwelling place for us,” v. 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "Li-U"
  }, [_vm._v("III."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Lament: for God’s harsh discipline of humankind and of sinful Israel, vv. 3–10")])]), _vm._v(" "), _c('p', {
    staticClass: "Li-U"
  }, [_c('span', {
    staticClass: "space025"
  }, [_vm._v("IV."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Petitions for salvation: vv. 13–17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Li-U"
  }, [_c('span', {
    staticClass: "space05"
  }, [_vm._v("V."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Praise: vv. 14b–15")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("More precisely, it is, as Robert Alter says, “a collective penitential supplication.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26",
      "id": "fn26"
    }
  }, [_vm._v("26")])]), _vm._v(" So Marvin Tate plausibly postulates as its appropriate context “a worship "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("service of communal prayers of lament” similar to that of Joel 2:12–17 (note the use of "), _c('i', [_vm._v("šwb")]), _vm._v(" and "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("nḥm")])]), _vm._v(" in Joel 2:14 and Ps. 90:13)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27",
      "id": "fn27"
    }
  }, [_vm._v("27")]), _vm._v(" But the psalm also has the characteristics of wisdom literature. The hinge on which the psalm swings from lament (11) to petitions (12) combines the prayer genre with the genre of wisdom literature. “To gain wisdom” provides the motivation “to number days” (v. 12). The lament over burdensome toil and its futility (v. 10) strikingly resembles the wisdom book of Ecclesiastes."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28",
      "id": "fn28"
    }
  }, [_vm._v("28")])]), _vm._v(" In sum, the psalm’s “unmistakable stamp” of being a national song of complaint combined with the unmistakable stamp of the wisdom genre makes it, as von Rad put it, “a stranger in the Old Testament.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29",
      "id": "fn29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Rhetoric and Structure")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Phyllis Trible deftly defines form and rhetorical criticisms: “Whereas form criticism studies the typical and so groups literature according to its genres, rhetorical criticism studies the particular within the typical. Its guiding rubric declares that ‘proper’ [or appropriate] articulation of form-content yields proper [or appropriate] articulation of meaning.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30",
      "id": "fn30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The psalm is framed by two of "), _c('i', [_vm._v("I AM")]), _vm._v("’s titles, “Lord"), _c('i', [_vm._v("”")]), _vm._v(" and “God,” and by the chronological notices of “generation to generation” and “their descendants” (vv. 1, 16). The anagram "), _c('i', [_vm._v("mā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("ôn")]), _vm._v(" (“dwelling place,” v. 1) and "), _c('i', [_vm._v("nō"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("am")]), _vm._v(" (“beauty,” v. 17) may be an intentional frame. Here is an outline of the psalm’s stanzas and strophes:"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31",
      "id": "fn31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('table', {
    staticClass: "Table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "acl",
    attrs: {
      "id": "s-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#s1"
    }
  }, [_vm._v("Superscript")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s1"
    }
  }, [_vm._v("1a")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl",
    attrs: {
      "id": "s-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s2"
    }
  }, [_vm._v("Stanza I: Doxological Invocation")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s2"
    }
  }, [_vm._v("1b–2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl",
    attrs: {
      "id": "s-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s3"
    }
  }, [_vm._v("Stanza II (Lament): Death and Sin")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s3"
    }
  }, [_vm._v("3–10")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl1",
    attrs: {
      "id": "s-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s4"
    }
  }, [_vm._v("Strophe A: The Certainty of Death and Brevity of Life")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s4"
    }
  }, [_vm._v("3–6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl2",
    attrs: {
      "id": "s-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s5"
    }
  }, [_vm._v("1. In Contrast to the Sovereign’s Eternity")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s5"
    }
  }, [_vm._v("3–4")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl2",
    attrs: {
      "id": "s-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s6"
    }
  }, [_vm._v("2. In Comparison to Grass")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s6"
    }
  }, [_vm._v("5–6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl1",
    attrs: {
      "id": "s-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s7"
    }
  }, [_vm._v("Strophe B: Israel’s Punishment for Sin")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s7"
    }
  }, [_vm._v("7–10")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl2",
    attrs: {
      "id": "s-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s8"
    }
  }, [_vm._v("1. Death for Sin")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s8"
    }
  }, [_vm._v("7–8")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl2",
    attrs: {
      "id": "s-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s9"
    }
  }, [_vm._v("2. Punishment Lasts Seventy or Eighty Years")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s9"
    }
  }, [_vm._v("9–10")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl",
    attrs: {
      "id": "s-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s10"
    }
  }, [_vm._v("Stanza III (Hinge): Lament and Petition to Gain Wisdom")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s10"
    }
  }, [_vm._v("11–12")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl1",
    attrs: {
      "id": "s-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s11"
    }
  }, [_vm._v("Strophe A (Lament): Few Know God’s Wrath against Sin and the Fear Due Him")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl1",
    attrs: {
      "id": "s-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s12"
    }
  }, [_vm._v("Strophe B Petition: To Know by Numbering Days")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl",
    attrs: {
      "id": "s-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s13"
    }
  }, [_vm._v("Stanza IV (Petitions): Relent from Anger and Bless Israel")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s13"
    }
  }, [_vm._v("13–17")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl1",
    attrs: {
      "id": "s-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s14"
    }
  }, [_vm._v("Strophe A: Relent from Punishment")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s14"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl1",
    attrs: {
      "id": "s-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s15"
    }
  }, [_vm._v("Strophe B: Confer Benedictory Blessings")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s15"
    }
  }, [_vm._v("14–17")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl2",
    attrs: {
      "id": "s-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s16"
    }
  }, [_vm._v("1. To Rejoice in God’s Unfailing Love in His Saving Deeds")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s16"
    }
  }, [_vm._v("14–15")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "acl2",
    attrs: {
      "id": "s-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s17"
    }
  }, [_vm._v("2. To See God’s Saving Deeds and to Establish the Israelites’ Work")])]), _c('td', {
    staticClass: "tdright"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s17"
    }
  }, [_vm._v("16–17")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Temporal catchwords unify the psalm’s stanzas, strophes, and couplets: “generation to generation,” “eternity to eternity,” and “before” (vv. 1–2); “yesterday” and “watch in the night” (v. 4); “morning” (vv. 5, 6, 14) and “night” (v. 6); “years” (vv. 9, 10, 15) and “days” (vv. 9, 10, 12, 14, 15); and “how long” (v. 13). Konrad Schaefer notes the katabasis in the invocation and lament: from “eternity to eternity” to “a thousand years,” “yesterday,” “a watch in the night,” and “morning” and “evening” (vv. 1–6). He also notes an anabasis in the benedictory petitions: from “morning” to “days” and “years” (vv. 14–15)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32",
      "id": "fn32"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Terms for God’s anger unify the second and third stanzas: “anger” (vv. 7a, 11), “wrath” (v. 7b), “fierce anger” (vv. 9, 11). The stanzas and strophes are also linked by the logic of Israel’s covenants: sin and death (vv. 3–10), fear of "), _c('i', [_vm._v("I AM")]), _vm._v(" and wisdom (vv. 11–12), and repentance and restoration (vv. 13–17).")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("Author")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Intertextual evidence supports the historical credibility of the claim that Moses composed the psalm. The psalm shares some language with Deuteronomy 32–33,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33",
      "id": "fn33"
    }
  }, [_vm._v("33")]), _vm._v(" and as an intercessory prayer, it fits well on the lips of Moses, the great intercessor for Israel (see Exod. 32:11-13, 31-32; Num. 14:13-19; Deut. 9:25-29; Ps. 106:23; Jer. 15:1; see also Ps. 99:6). F. Delitzsch comments: “There is scarcely any written memorial of antiquity which so brilliantly justifies the testimony of tradition concerning its origin as does this Psalm.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34",
      "id": "fn34"
    }
  }, [_vm._v("34")])]), _vm._v(" But the academic consensus for over a century dates the psalm to the exilic or postexilic era."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35",
      "id": "fn35"
    }
  }, [_vm._v("35")])]), _vm._v(" Mischievously, “the consensus” subverts the evidence that supports the superscript’s historical credibility by claiming that the evidence explains the origin of the alleged pseudograph (i.e., a forgery)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36",
      "id": "fn36"
    }
  }, [_vm._v("36")])]), _vm._v(" Tate argues that the term “your servants” locates the psalm in postexilic communities,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37",
      "id": "fn37"
    }
  }, [_vm._v("37")])]), _vm._v(" but he curiously overlooks the use of that term by Moses (Exod. 32:13), Solomon (1 Kgs. 8:32), and Asaph (Ps. 79:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But cracks are now showing in the academic consensus, though none yet dares to affirm the tradition. H.-J. Kraus characterizes the psalm as preexilic (ninth century) largely because of its resemblances to Deuteronomy 32 and the “J” story in Genesis 2–3."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38",
      "id": "fn38"
    }
  }, [_vm._v("38")])]), _vm._v(" Mitchell Dahood dates the psalm as an early (ninth-century?) "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("composition because of its archaic language."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39",
      "id": "fn39"
    }
  }, [_vm._v("39")]), _vm._v(" Walter Brueggemann suggests it be heard as if Moses were at Pisgah (Deut. 34)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40",
      "id": "fn40"
    }
  }, [_vm._v("40")])]), _vm._v(" David Noel Freedman notes that on the occasion of the golden calf episode, Moses prayed using the same two imperatives as in verse 13: “Turn ("), _c('i', [_vm._v("šûb")]), _vm._v(") from your fierce anger; relent ("), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("w"), _c('sup', [_vm._v("e")]), _vm._v("hinnāḥēm")])]), _vm._v(") and do not bring disaster on your people” (Exod. 32:12). He comments, “Aside from Amos, only Moses intercedes successfully with Yahweh and obtains his repentance” (see Exod. 32:14). So Freedman suggests that whoever composed Psalm 90 based it on the episode in Exodus 32 and imagined in poetic form how Moses may have spoken in those circumstances."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41",
      "id": "fn41"
    }
  }, [_vm._v("41")])]), _vm._v(" Beth L. Tanner explores the psalm’s superscription in light of Exodus 32-34 and Deuteronomy 32-33 and argues the superscription was added so that the psalm would be read “intertextually with the wilderness narrative and the final prayer and blessings of Moses.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42",
      "id": "fn42"
    }
  }, [_vm._v("42")])]), _vm._v(" Gerald T. Sheppard notes its placement after Psalm 89: “Moses intercedes on behalf of Israel who has been given a divine promise that now seems to be in jeopardy.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43",
      "id": "fn43"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The superscript to the Targum identifies the historical setting as “when the people, the house of Israel, sinned in the wilderness.” The historical context of the dying-off generation during the closing years of Moses’s life aptly fits the psalm’s dark tone and minor key. The exodus-wilderness generation spent their last forty years wandering around in a cemetery, a harsh wilderness, a land of scorpions and venomous snakes. For their unbelief at Kadesh Barnea they died off in natural deaths and never reached the promised land (see Psalm 95). The wilderness generation killed time in meaningless wanderings (Num. 14:33). And so do moderns with no metanarrative by which to interpret the meaning of their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It may be justly urged, however, that the psalm’s restriction of human life to at best eighty years (v. 10) does not comport well with Moses’s and Aaron’s life-spans of 120 and 123 years respectively (Deut. 34:7; Num. 33:39) or with "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Joshua’s 110 years (Josh. 24:29) and Caleb’s strength at 85 years of age (Josh. 14:10). But these four are the exceptions. Deuteronomy 34:7 implies Moses was exceptional by its notation: “when he [Moses] died, his eye was not dim nor was his natural vitality diminished.” If this were normal, why mention it? Caleb explained his extraordinary full strength at eighty-five years of age—forty-five years after the exodus—as due to "), _c('i', [_vm._v("I AM")]), _vm._v("’s unique promise to him (Josh. 14:10). The longevity of these four great men of the exodus-wilderness generation, which merits biblical notices, actually proves the psalm’s rule for the majority of Israel. Moses’s epithet “man of God” calls the audience of his prayer to take their shoes off their feet; they are standing on holy ground.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("The Speakers")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Moses may be the author, but he prays with the dynamic of “you—we,” not “you—I,” confident that the eternal God has uniquely adopted Israel, “your servants” (vv. 13, 16), as his family (cf. Ps. 100:3). The speakers are chastened penitents who are firm in their faith. They belong to Joshua’s generation that entered the promised land, the offspring of the wilderness generation, whom God barred from that land. By faith they invoke God as their eternal dwelling place (vv. 1–2). By faith, like Daniel (9:4–20) and Ezra (9:5–15), they confess their sin as part of corporate Israel (vv. 3–10). By faith, they petition "), _c('i', [_vm._v("I AM")]), _vm._v(" to enlighten them (vv. 11–12) and save them in the morning of a new age (vv. 13–17). The “we” is corporate and personal: As individuals they live seventy or eighty years (v. 10a); as a community they endure throughout generations and experience God’s covenantal wrath in the hope of his covenantal promises. The relationship of the individual to the group is like leaves on a tree: Each has its own days and years, but those days and years are inseparable from the corporate whole. Today the “we” is the church being built by Jesus Christ. The church is the seed of Abraham (Gal. 3:29). The Jewish leadership said no to God’s Son, and God said, “They are not my people.” But at the end of history as we know it, ethnic Israel will repent and identify with Jesus Christ and his church."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44",
      "id": "fn44"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s4"
    }
  }, [_vm._v("II. Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "H2",
    attrs: {
      "id": "s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-1"
    }
  }, [_vm._v("Superscript 1a")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("A "), _c('i', [_vm._v("prayer")]), _vm._v(" here means “an intercession.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn45",
      "id": "fn45"
    }
  }, [_vm._v("45")])]), _vm._v(" H. P. Stähli notes that prayer has four characteristics: (a) directed toward God; (b) for Israel; (c) “usually in the face of God’s wrath and punishment for sin”; and (d) the interceders “in older texts are esp. the powerful men (of God): Abraham (. . . Gen. 20:7, 17 . . .), Moses (Num. 11:2 . . . ; 21:7 ; Deut. 9:26), Samuel (1 Sam. 7:5; 12:19, 23; cf. Jer. 15:1).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn46",
      "id": "fn46"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('i', [_vm._v("By Moses")]), _vm._v(" (see “Author”). "), _c('i', [_vm._v("The man of God")]), _vm._v(" refers to a true prophet (cf. Hab. 3:1): one who is highly respected by the faithful and is pious, devoted, godly, and charismatic."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn47",
      "id": "fn47"
    }
  }, [_vm._v("47")])]), _vm._v(" Manoah’s wife called the awesome angel of "), _c('i', [_vm._v("I AM")]), _vm._v(" who appeared to her “the man of God” (Judg. 13:6, 8). The epithet assures the faithful that God will answer this prayer, for “the prayer of a righteous person is powerful and effective” (Jas. 5:16).")]), _vm._v(" "), _c('p', {
    staticClass: "H2",
    attrs: {
      "id": "s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-2"
    }
  }, [_vm._v("Stanza I: Doxological Invocation 1b–2")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Pierre Auffret notes the artistic structure of verses 1–2."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn48",
      "id": "fn48"
    }
  }, [_vm._v("48")])]), _vm._v(" Reference to the "), _c('i', [_vm._v("Lord/Dwelling Place")]), _vm._v(" and "), _c('i', [_vm._v("God,")]), _vm._v(" followed and preceded respectively by an emphatic "), _c('i', [_vm._v("you")]), _vm._v(", frames the invocation around chiastic references to universal time (“generation to generation” and “from eternity to eternity”) and global space (“mountains” and “earth/world”) which “were born/you brought forth.” Verse 1 looks to God’s help to past generations of Israel. "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Verse 2 takes their situation beyond that into the context of God’s eternity, before the earth existed. The transcendent Sovereign over time and space humbled himself and entered both spheres to be forever Israel’s home—a foretaste fulfilled in the incarnation in Jesus Christ. Craig Broyles notes: “Psalm 90 uses the praise of God as a platform from which it can express a persuasive appeal.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn49",
      "id": "fn49"
    }
  }, [_vm._v("49")]), _vm._v(" The supplicants will never be homeless, for their God—today to be known in his Son (see p. 2–3)—is eternal, and he made himself their refuge. However deep our sin and desperate our plight, "), _c('i', [_vm._v("I AM")]), _vm._v(" remains the home of his chosen family.")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("1")]), _vm._v(" The unique address in the Psalter, "), _c('i', [_vm._v("O Lord")]), _vm._v(" ("), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _c('sup', [_vm._v("a")]), _vm._v("dōnāy")]), _vm._v(") means “Lord of all.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn50",
      "id": "fn50"
    }
  }, [_vm._v("50")])]), _vm._v(" The title is appropriate because the supplicants conceptualize themselves as his servants (vv. 13 and 16). "), _c('i', [_vm._v("You")]), _vm._v(" is tautological and so emphatic. "), _c('i', [_vm._v("Have been")]), _vm._v(" holistically represents a situation that encompasses the past and the present (cf. Ps. 10:14)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn51",
      "id": "fn51"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('i', [_vm._v("For us")]), _vm._v(" (i.e. Israel, see p. 13). The Sovereign began to be Israel’s dwelling place when he uniquely adopted the patriarchs as his sons and later formed their descendants into a nation through Moses (see Ps. 100:3). Today the “us” is the church: Jews and Gentiles (see Rom. 4:17; Gal. 3:26–29; 1 Pet. 2:9–10)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn52",
      "id": "fn52"
    }
  }, [_vm._v("52")])]), _vm._v(" The Eternal’s election of nomads and nobodies, schmucks and schlemiels, is the scandal of history. Elsewhere, "), _c('i', [_vm._v("dwelling place")]), _vm._v(" is used both of heaven (Deut. 26:15), which is reached through prayer (2 Chr. 30:27), and of God’s earthly temple (1 Sam. 2:29; 2 Chr. 36:15; Ps. 26:8). Here, it is used metaphorically, as indicated by the likening of God, who is spirit, to a physical abode—a place of provision, trust, loyalty, communion, comfort, stability, and security. He himself provides what the temple provided. Israel’s temple may have been gone when Book IV was compiled (see p. 15–16) but not their covenantal relationship with God. Only the faithful find "), _c('i', [_vm._v("I AM")]), _vm._v(" their refuge (Ps. 91:9–10) and that faith cannot be separated from his eternal law. Brueggemann comments: “The speaker is not homeless. There is a center to prevent fragmentation. There is a belonging to preclude isolation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn53",
      "id": "fn53"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('i', [_vm._v("Throughout generations")]), _vm._v(" signals an endless succession of generations from Abraham to the present. The faithful conquest generation remained almost as numerous as the dead wilderness generation: like the stars in the sky (Deut. 1:10; cf. Num. 26:51, 62 with Num. 1:46). "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("God’s people have sufficient reason to sing: “Our help in ages past, our hope for years to come . . . and our eternal home.”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" In the ancient world’s cosmology, "), _c('i', [_vm._v("the mountains")]), _vm._v(" are the foundations of the earth in the midst of the primeval ocean depths, so here they are mentioned first (cf. Jonah 2:6[7]; Ps. 104:6–8). As the ocean depths represent primeval chaos, the mountains represent the oldest parts of the earth, which sustained life at the beginning of historical time (cf. Micah 6:2). "), _c('i', [_vm._v("Were born")]), _vm._v(" may be a figurative echo of an ancient mythical idea that mother earth suffered labor pains in giving birth to the mountains. "), _c('i', [_vm._v("And you brought to birth")]), _vm._v(" clearly identifies Israel’s God as the Agent. Thus Moses polemicizes against the pagan mother-earth myth, just as Milton polemicized against Greek myths using their own subject matter. "), _c('i', [_vm._v("The earth")]), _vm._v(" probably refers to the land that sustains life and, in the cosmology of the biblical world, stands in contrast to the chaotic seas around it, to the unfathomable depths below, and to the unattainable heavens above. Philip Sumpter defines the Hebrew word for "), _c('i', [_vm._v("the world")]), _vm._v(" ("), _c('i', [_vm._v("tēbēl")]), _vm._v(") as “the earth-disc . . . which is the "), _c('i', [_vm._v("ground")]), _vm._v(" [italics his] for the existence of its inhabitants.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn54",
      "id": "fn54"
    }
  }, [_vm._v("54")]), _vm._v(" Christopher J. H. Wright notes: “It is used frequently in contexts both that associate it with Yahweh’s creative act and that, as a result, express the stability or durability of the earth (1 Sm 2:8; Pss. 89:11[12]; 93:1; 96:10).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn55",
      "id": "fn55"
    }
  }, [_vm._v("55")])]), _vm._v(" Matching the universal population of the world (cf. Pss. 24:1; 33:8; 98:7; Isa. 18:3; Nah. 1:5) are the temporal terms "), _c('i', [_vm._v("throughout generations")]), _vm._v(" and "), _c('i', [_vm._v("from eternity to eternity")]), _vm._v(". “Eternity” ("), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("ôlām")]), _vm._v(") often denotes the most remote time in the past or future. But in contexts where it refers to God, like this one, it has its full philosophical sense: “Only in expressly theological and doxological contexts to be translated ‘eternally, in eternity.’ ”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn56",
      "id": "fn56"
    }
  }, [_vm._v("56")])]), _vm._v(" Israel’s God is Lord of all, transcending all in space and time. The confession "), _c('i', [_vm._v("you")]), _vm._v(" (see “Stanza I: Doxological Invocation 1b–2” above) "), _c('i', [_vm._v("are God")]), _vm._v(" ("), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("ēl")]), _vm._v(", see 100:3) implies that Israel’s God “has an unlimited abundance of power and a presence that overcomes the barriers of time.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn57",
      "id": "fn57"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2",
    attrs: {
      "id": "s3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#s-3"
    }
  }, [_vm._v("Stanza II (Lament): Death and Sin 3–10")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The enormous discrepancy between God’s time and ours is not inherent in creation but historically conditioned.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Creator’s original intention for the unending life of the sinless human has not been rescinded but accomplished through the man Christ Jesus. In the prodigal penitents’ implicit return to their eternal home, they confess that their sin cut their lives off the loom and their days are like smoke. Now, God’s eternal nature stands in sharp contrast to the sinful mortal’s infinitesimally brief existence (v. 4). As the enemy of sinners, God circumscribes the depraved mortal’s’ brief days within seventy, or at best eighty, years (vv. 3–10).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This dark stanza on mortality has two equal strophes of four verses: verses 3–6 pertain to mortals in general and 7–10 pertains to “we” (i.e., Israel). The two strophes are linked by “surely,” by the theme of the brevity of the mortal’s life, and by the logic of covenant theology: death (vv. 3–6) is due to God’s wrath against sin (vv. 7–10). That all die is science; that God abases humanity is theology. Death is at God’s “absolute disposal.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn58",
      "id": "fn58"
    }
  }, [_vm._v("58")])]), _vm._v(" This harsh realism regarding life’s brevity is similar to that of the Preacher in the Book of Ecclesiastes. Weiser comments: “[Death points] to the other eternal reality which transcends the evanescent life of man and which alone is able to impart to it a lasting purpose and value. There is no other way to a genuine faith than the one which continually compels a man in remorseless sincerity to abandon all hope in his own strength and cast himself whole upon God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn59",
      "id": "fn59"
    }
  }, [_vm._v("59")])]), _vm._v(" This sober view of death, however, must be held in tension with a robust affirmation of Israel’s triumph: “No misfortune is seen in Jacob, no misery observed in Israel. "), _c('i', [_vm._v("I AM")]), _vm._v(" their God is with them; the shout of the King is among them” (Num. 23:21).")]), _vm._v(" "), _c('p', {
    staticClass: "H3",
    attrs: {
      "id": "s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-4"
    }
  }, [_c('i', [_vm._v("Strophe A: The Certainty of Death and Brevity of Life 3–6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The first couplet (vv. 3–4) is linked by the medial “surely” (v. 4) and the second couplet (vv. 5–6) by the repetition of the catchword “in the morning.” The two couplets are thematically linked in their initial verses by the agent, "), _c('i', [_vm._v("you")]), _vm._v(", who rules death (vv. 3, 5), and by their elaboration on the mortal’s death, first by contrasting the brevity of life with God’s eternity (v. 4) and then by comparing it to grass that blossoms in the morning and dies in the evening (v. 6). "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("The comparison to grass also illuminates the mortal’s transience in contrast to God’s immutability. All people know the brevity of this life, but almost all foolishly cling to the transient things of this world, flattering themselves that their pictures will not appear in tomorrow’s obituary page. Few wisely cling to the eternal God.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('p', {
    staticClass: "H4",
    attrs: {
      "id": "s5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#s-5"
    }
  }, [_vm._v("1. In Contrast to the Sovereign’s Eternity 3–4")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("3")]), _vm._v(" "), _c('i', [_vm._v("Return . . . to dust")]), _vm._v(" is one of several idioms for death (cf. Job 34:15; Ps. 104:29; Eccl. 3:20); it can be inferred a person ought not to put their trust in mortals (cf. Ps. 146:4; Prov. 11:7). “Return” evokes the understanding that human bodies originated from the ground. Whereas “dust” ("), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("āpār")]), _vm._v(") in Gen. 3:19 denotes “dry, loose, ground,” the term used here for "), _c('i', [_vm._v("dust")]), _vm._v(" ("), _c('i', [_vm._v("dakkā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")])]), _vm._v(") derives from the verb “to crush” (cf. Isa. 3:15) and may connote humankind’s total defeat. "), _c('i', [_vm._v("The mortal")]), _vm._v(" ("), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _c('sup', [_vm._v("e")]), _vm._v("nōš)")]), _vm._v(" denotes the male in his weakness. "), _c('i', [_vm._v("You say")]), _vm._v(" “"), _c('i', [_vm._v("return")]), _vm._v("” reprises God’s direct word to Adam, mankind’s representative: “To the dust you will return” (Gen. 3:19). "), _c('i', [_vm._v("Mankind")]), _vm._v(" ("), _c('i', [_vm._v("b"), _c('sup', [_vm._v("e")]), _vm._v("nê "), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("ādām")]), _vm._v(", lit. “sons of humankind”) represents the nature, quality, character, or condition of a “son” (i.e., a person) as an “"), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("ādām")]), _vm._v(",”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn60",
      "id": "fn60"
    }
  }, [_vm._v("60")])]), _vm._v(" a noun probably derived from "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _c('sup', [_vm._v("a")]), _vm._v("dāmâ")]), _vm._v(", (“ground”). Mankind was created a mortal, but this became “a realized mortality” only when he ate the forbidden fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("4")]), _vm._v(" A "), _c('i', [_vm._v("thousand")]), _vm._v(" is the largest round figure that can exist in multiples for counting and here serves as a symbol for an extremely long period of time (cf. Deut. 7:9; Pss. 50:10; 84:10). Were a specific number intended, “about” (cf. Exod. 12:37; 32:28; Josh. 4:13) could have readily been added."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn61",
      "id": "fn61"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('i', [_vm._v("Years")]), _vm._v(" has its conventional sense of calendar years and stands in contrast to other chronological terms (e.g., “day,” “week,” “month”) as the largest measure of time."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn62",
      "id": "fn62"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('i', [_vm._v("In your estimation")]), _vm._v(" contrasts the viewpoint of time from the perspective of the eternal with that of the temporal. If a thousand years of human time is like twenty-four hours to God, then seventy or eighty years is like less than two hours. "), _c('i', [_vm._v("Is like yesterday")]), _vm._v(" could refer either to a full day of twenty-four hours or to the daylight hours of a previous time. “Day” has both senses in Genesis 1:5. The parallel “night” (v. 4b) favors the meaning of “daylight” (cf. Neh. 4:16; Job 3:3; Hos 4:5). "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('i', [_vm._v("When it is over")]), _vm._v(" adds notions of life’s fleeting, ephemeral and futile nature. To paraphrase the Preacher: “It’s all utter vanity” (lit. “a puff of air,” like a puff of cigar-smoke, Eccl. 1:2, 5). The day is spent and cannot be recovered. Even the simile of “yesterday” is too long—the thousand years are more like "), _c('i', [_vm._v("a watch")]), _vm._v(" in the night, the four hours a watchman stands his post to protect the people while they sleep."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn63",
      "id": "fn63"
    }
  }, [_vm._v("63")]), _vm._v(" Accordingly, the mortal’s seventy or eighty years are like a little over a quarter of an hour in the scope of a day to God. As “watch” intensifies “day,” so "), _c('i', [_vm._v("in the night")]), _vm._v(" intensifies “when it is over”—that is to say, it intensifies life’s ephemeral nature. Delitzsch comments: “It is certainly not without design that the poet says "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("ašmûrâ ballāylâ")]), _vm._v(" [‘watch in the night’] not "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("ašmōret hallāylâ")]), _vm._v(" [‘watch of the night’]. The night-time is the time for sleep.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn64",
      "id": "fn64"
    }
  }, [_vm._v("64")])]), _vm._v(" Kirkpatrick comments: “Time no more exists for God than it does for the unconscious sleeper.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn65",
      "id": "fn65"
    }
  }, [_vm._v("65")])]), _vm._v(" (Cf. 2 Pet. 3:8 and Sir. 18:10, which affirm the converse of this verse.)")]), _vm._v(" "), _c('p', {
    staticClass: "H4",
    attrs: {
      "id": "s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-6"
    }
  }, [_vm._v("2. In Comparison to Grass 5–6")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The notion of an unconscious sleeper in the night segues into the notion of the sleep of death. The simile likening the brevity of life to grass demands that the blossoming of grass in the morning (v. 5b) be contrasted with its withering in the evening (v. 6b). To join them, the poet essentially repeats the first and last words of 5b in 6a: “in the morning . . . is renewed.”")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("5")]), _vm._v(" "), _c('i', [_vm._v("You make an end of their lives")]), _vm._v(" (see n. 4) keeps the focus on God’s sovereignty and on humankind’s brevity. The metaphor "), _c('i', [_vm._v("they fall into deep sleep")]), _vm._v(" connotes death (see Job 14:12; Ps. 76:5–6; Jer. 51:39, 57; Nah. 3:18). "), _c('i', [_vm._v("In the morning")]), _vm._v(" denotes daybreak."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn66",
      "id": "fn66"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('i', [_vm._v("Like grass")]), _vm._v(" ("), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("keḥāṣîr")])]), _vm._v(") refers to “wild growth that comes "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("up regularly and abundantly after the winter rains (Ps. 147:8). . . . As quickly as "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("ḥāṣîr")])]), _vm._v(" sprouts in the rain, it withers in draught (Is. 15:6) or is found along streams at best (1 Kgs. 18:5).”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn67",
      "id": "fn67"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("6")]), _vm._v(" Two sets of verbs describe the states of renewal and death: “to blossom” and “be renewed” versus “to wither” and “dry up.” The similes reinforce the notion of humanity’s brevity and futility. That the grass "), _c('i', [_vm._v("blossoms")]), _vm._v(" signifies that for a brief moment humanity experiences health and vigor. The narrative "), _c('i', [_vm._v("waw")]), _vm._v(" with "), _c('i', [_vm._v("and is renewed")]), _vm._v(" may be logical (“and so it is renewed”). "), _c('i', [_vm._v("In the evening")]), _vm._v(" (see Ps. 30:5[6]) refers to sunset."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn68",
      "id": "fn68"
    }
  }, [_vm._v("68")])]), _vm._v(" According to Ps. 37:2, grass "), _c('i', [_vm._v("withers")]), _vm._v(" quickly "), _c('i', [_vm._v("and dries up")]), _vm._v(" (cf. Isa. 15:6; Job 18:16).")]), _vm._v(" "), _c('p', {
    staticClass: "H3",
    attrs: {
      "id": "s7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-7"
    }
  }, [_c('i', [_vm._v("Strophe B: Israel’s Punishment for Sin 7–10")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The second strophe adds three truths: (a) Israel’s death is due to God’s wrath against iniquities (vv. 7–9); (b) a person’s span of years is seventy or at best eighty years (v. 10a)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn69",
      "id": "fn69"
    }
  }, [_vm._v("69")])]), _vm._v("; and (c) mankind’s proud achievements are futile (v. 10b). Its first couplet (vv. 7–8) is linked by covenant logic: God’s wrath (v. 7) is provoked by sin (v. 8) (cf. Jer. 4:4)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn70",
      "id": "fn70"
    }
  }, [_vm._v("70")])]), _vm._v(" Its second couplet (vv. 9–10) is linked by the catchwords “days” and “years,” by the medial “surely,” by the escalating synonyms “in your anger and in your wrath” (v. 7) and “in your fierce anger” (v. 9), and by the lexeme "), _c('i', [_vm._v("kālâ")]), _vm._v(" (Qal"), _c('i', [_vm._v(",")]), _vm._v(" “perish,” v. 7; Piel, “finish,” v. 9). In sum, of the five words in verse 7, two are repeated by a synonym in verse 9. With these tight sutures the poet shows that due to God’s wrath, a person’s life is restricted to seventy or at best eighty years (v. 10a). The setting of universal death (vv. 3–6) and human experience before modern medicine suggest that Moses has in mind all the generations of Israel, not just his own. Accordingly, the strophe’s verbs are gnomic; they represent the situations of God’s burning wrath holistically."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn71",
      "id": "fn71"
    }
  }, [_vm._v("71")])]), _vm._v(" God’s righteous volition deconstructs all humankind’s insolent volition.")]), _vm._v(" "), _c('p', {
    staticClass: "H4",
    attrs: {
      "id": "s8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#s-8"
    }
  }, [_vm._v("1. Death for Sin 7–8")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Kidner aptly comments on verses 7–8: “We are shown God’s wrath as doubly irresistible, by its vigor and by its justice, leaving us with no resource (v. 7) and no excuse (v. 8).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn72",
      "id": "fn72"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("7")]), _vm._v(" In the chiastic parallels of verse 7, “anger” is intensified by “burning wrath” and “dismay” is added to "), _c('i', [_vm._v("perish")]), _vm._v(" ("), _c('i', [_vm._v("kālâ")]), _vm._v("; i.e, “come to a complete end, vanish, be destroyed”). "), _c('i', [_vm._v("In your anger")]), _vm._v(" (lit., “in your nostrils”) points to the physically visible state of an individual’s excitement seen in their breathing heavily as a consequence of anger. God’s anger differs from most examples of human anger: His anger results in deliberate judgment against sin (cf. Deut. 6:15)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn73",
      "id": "fn73"
    }
  }, [_vm._v("73")])]), _vm._v(" So his anger is not capricious but rather is his righteous response “to human deeds that violate his being and commandments.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn74",
      "id": "fn74"
    }
  }, [_vm._v("74")])]), _vm._v(" Jesus responded in anger to hardness of heart (Mark 3:5) and threatened God’s anger against the privileged few who spurned his invitation to enter the kingdom of heaven (Matt. 22:7). God’s wrath now rests on those who fail to believe in Jesus (John 3:36) and against those who suppress the truth (Rom. 1:18; 1 Thess. 2:16). Governing authorities serve as instruments of God’s anger to punish criminals (Rom. 13:4)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn75",
      "id": "fn75"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("Ap")]), _vm._v(" is used most frequently, as here, in parallel with "), _c('i', [_vm._v("wrath")]), _vm._v(" ("), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("ḥēmâ")])]), _vm._v("), a derivative of "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("yḥm")])]), _vm._v(" “to be hot.” The coordination of “anger” and “wrath” brings to a flash point the holy "), _c('i', [_vm._v("I AM’s")]), _vm._v(" burning anger against those who dishonor his Person and disobey his commandments. "), _c('i', [_vm._v("We are terrified")]), _vm._v(" may mean the whole skeleton is racked and shaken in fright (Ezek. 7:27; Ps. 6:2[3]) and denotes a psychological state of extreme fright at imminent threat (Gen. 45:3; Judg. 20:41; 1 Sam. 28:21), including death (Ps. 104:29). Moses’s unbelieving generation, whom "), _c('i', [_vm._v("I AM")]), _vm._v(" had duly warned and threatened, trembled from the prospect of divinely inflicted, premature death, not from a normal malady that creeps silently through the windows in old age (Eccl. 12:1–8)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn76",
      "id": "fn76"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" The penitent prodigals, unlike the wilderness generation, do not murmur against God for their plight. Verse 8 is the metonymy of the righteous and just cause for the physical afflictions in verse 7. The idiomatic anthropomorphism "), _c('i', [_vm._v("you set . . . before you")]), _vm._v(" means “you make conspicuous to you.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn77",
      "id": "fn77"
    }
  }, [_vm._v("77")]), _vm._v(" Like a good detective seeking justice, God deliberately searches out "), _c('i', [_vm._v("our iniquities")]), _vm._v(". "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("Awôn")]), _vm._v(" is the most holistic term in the semantic domain of sin; it encompasses both religious and ethical crimes and the resulting guilt. "), _c('i', [_vm._v("Our hidden sins")]), _vm._v(" is literally “our concealments,” a qualifying parallel to “our iniquities.” The anthropomorphism "), _c('i', [_vm._v("in the light of your face")]), _vm._v(" communicates regarding sins, which people hide from themselves by self-deception and conceal from others by hypocrisy, that the just God does not sweep them under the rug but exposes them. It is implicit that God exposes sins in order to right the wrong (cf. Prov. 20:27; 1 Cor. 2:11). "), _c('i', [_vm._v("Light")]), _vm._v(" is literally “place of light, luminary, lamp,” possibly a metonymy for “light” more generally. The apostle Paul warns: “He [the Lord] will bring to light what is hidden in darkness and will expose the motives of the heart” (1 Cor. 4:5). C. S. Lewis noted: “In the end that Face which is the delight or the terror of the universe must be turned upon each of us . . . either conferring glory inexpressible or inflicting shame that can never be cured or disguised.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn78",
      "id": "fn78"
    }
  }, [_vm._v("78")])]), _vm._v(" If one wants to understand the strength of God’s wrath against the sin of unbelief, do not look to the black and fanciful lines of Baxter, Bunyan or Milton, but look at ethnic Israel’s tragic history.")]), _vm._v(" "), _c('p', {
    staticClass: "H4",
    attrs: {
      "id": "s9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-9"
    }
  }, [_vm._v("2. Punishment Lasts Seventy or Eighty Years 9–10")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("9")]), _vm._v(" "), _c('i', [_vm._v("All our days")]), _vm._v(" (see v. 4) encompasses the entirety of our lives in their sequential, segmented daily components. That notion will pave the way into the psalm’s new insight to wisdom, namely to count our days (v. 12). "), _c('i', [_vm._v("Pass away")]), _vm._v(" translates "), _c('i', [_vm._v("pānâ")]), _vm._v(" (“to turn”). With “days” as its subject, this forms the idiom “the day turned away” (i.e., “drew to a close, disappeared”; cf. Jer. 6:4). The full scope of our days fades away and affords no hope of change, without the intervention of God’s grace through wisdom. "), _c('i', [_vm._v("In your fury")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn79",
      "id": "fn79"
    }
  }, [_vm._v("79")])]), _vm._v(" is a metonymy of cause for the daily toil that amounts to nothing (see v. 10). "), _c('i', [_vm._v("We finish our years")]), _vm._v(" (see v. 3; “perish,” v. 4). "), _c('i', [_vm._v("A sigh")]), _vm._v(" signifies a long deep breath emitting a soft, dull "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("sound that “vanishes into thin air (Rashi).”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn80",
      "id": "fn80"
    }
  }, [_vm._v("80")]), _vm._v(" This sound of sadness is the appropriate response to death, to the reality of God’s fierce anger against sin. Stoicism is not appropriate, for it fakes reality and refuses to be emotionally real in the presence of anger and death. Being truly sad makes a person long for something better (see 2 Cor. 5:2).")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("10")]), _vm._v(" Moses now numbers the mortals’ days as at best a brief eighty years, and all of them are toilsome and futile. They pass quickly, and once gone, they are gone forever."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn81",
      "id": "fn81"
    }
  }, [_vm._v("81")])]), _vm._v(" The idiom "), _c('i', [_vm._v("as for the days of our years")]), _vm._v(" refers to our entire lives (cf. Gen. 47:8). Mankind’s “days” "), _c('i', [_vm._v("are")]), _vm._v(" surrounded by the concomitant condition of "), _c('i', [_vm._v("seventy years")]), _vm._v(". "), _c('i', [_vm._v("Or if")]), _vm._v(" the days are accompanied "), _c('i', [_vm._v("with strength")]), _vm._v(" (see n. 7)"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn82",
      "id": "fn82"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('i', [_vm._v("eighty years")]), _vm._v(". The conjunction "), _c('i', [_vm._v("and")]), _vm._v(" joins the burdensome and deceptive quality of the days to their brief quantity. "), _c('i', [_vm._v("And their proud achievements")]), _vm._v(" (see n. 8) understands with BDB and others that "), _c('i', [_vm._v("rōhab")]), _vm._v(" is a metonymy for “objects of pride.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn83",
      "id": "fn83"
    }
  }, [_vm._v("83")])]), _vm._v(" More precisely "), _c('i', [_vm._v("rōhab")]), _vm._v(" means “insolent pride.” In their hubris, mortals strive to achieve what they call “success” independently from God and credit their achievements to the power and strength of their own hands, not to God "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("who gave them ability (cf. Deut. 8:17–18; James 4:13–17). Their self-glorifying achievements are "), _c('i', [_vm._v("toilsome")]), _vm._v(", or“burdened with grief” ("), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("āmāl")]), _vm._v(")."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn84",
      "id": "fn84"
    }
  }, [_vm._v("84")]), _vm._v(" Schwertner, citing Ps. 90:10, notes the basic meaning of "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("āmal")]), _vm._v(" “indicates primarily the process of work . . . and the trouble that it causes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn85",
      "id": "fn85"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('i', [_vm._v("And futile")]), _vm._v(" (cf. James 4:14). Shakespeare’s Mark Antony lamented over the corpse of Julius Caesar: “O mighty Caesar, dost thou lie so low?/ Are all thy conquests, glories, triumphs, spoils/ Shrunk to this little measure?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn86",
      "id": "fn86"
    }
  }, [_vm._v("86")])]), _vm._v(" Humans deceive themselves when they think their achievements will gain them social immortality and praise. They name streets after themselves and write posthumous memoirs. They might just as well write their names on water. They build monumental architecture, but most of it winds up only as foundation stones that are uncovered by the archeologist’s spade, and the few that remain above ground are skeletons. Their mansions are sand-castles that the tide inexorably washes away. "), _c('i', [_vm._v("For")]), _vm._v(" introduces a causal clause that explains why the mortal’s proud achievements are futile: "), _c('i', [_vm._v("they pass away quickly")]), _vm._v(" (see n. 11). The metaphor "), _c('i', [_vm._v("and we fly away")]), _vm._v(" (cf. Prov. 23:5) connotes speed and that once we are gone, we are gone forever. Weiser comments: “No wonder that a man who seeks in life "), _c('i', [_vm._v("his")]), _vm._v(" will and "), _c('i', [_vm._v("his")]), _vm._v(" pleasure is bound to end in this disappointment; for all pleasure seeks perpetuity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn87",
      "id": "fn87"
    }
  }, [_vm._v("87")])]), _vm._v(" But the psalm’s final word is “establish the works of our hands” (v. 17).")]), _vm._v(" "), _c('p', {
    staticClass: "H2",
    attrs: {
      "id": "s10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-10"
    }
  }, [_vm._v("Stanza III (Hinge): Lament and Petition to Gain Wisdom 11–12")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Logic and catchwords screw the hinge stanza into the lament stanza (vv. 3–10): “your anger” (vv. 7, 11a) and “your fierce anger” (vv. 9, 11b); “our days” and “the days of our years” (vv. 10, 12). Having numbered the mortal’s days to seventy or eighty years (v. 10a), the penitents are now able to number their own days (vv. 12a). Similarly, logic and form screw the hinge into the petition stanza (vv. 13–17): petition and wise hearts (v. 12b) are what God blesses (vv. 13–17). The hinge stanza itself is unified by the lexeme "), _c('i', [_vm._v("yāda"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(" (Qal, “to know,” v. 11; Hiphil “cause to know,” v. 12). Indeed, the objects of “cause us to know” (v. 12a) are the double objects of what none or few know (v. 11). Also, the wise hearts of verse 12b are inseparable from knowing “the fear due you” (v. 11b; cf. Prov. 1:7; Job 28:20–28; Eccl. 12:13–14). The hinge swings the psalm from the sober "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("despair of the lament to the bright hope of the petitions. Christine Forster notes numerous key words that point to the reversal:")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('p', {
    staticClass: "EX"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("The root "), _c('i', [_vm._v("šûb")]), _vm._v(" in 13 points back to v. 3, but now refers not to the mortal’s “return” to dust, but instead to YHWH’s “return” to the petitioners or the “turning away” from his wrath. Verse 14 takes up "), _c('i', [_vm._v("bbqr")]), _vm._v(" [“in the morning”] from vv. 5–6. What in the earlier verses was part of an image for mortality now describes the morning as a time in which YHWH will again prove himself gracious. Verses 14 and 15 with ("), _c('i', [_vm._v("kl-ymynw")]), _vm._v(" “all our days”) and ("), _c('i', [_vm._v("šnwt kymwt")]), _vm._v(" “according to the days/years”) refer back to v. 9. . . . In contrast to the lament there over the vanished years and days, what follows here is a petition for joy lasting just as many days and years. A major inclusion is created by the key work linkage "), _c('i', [_vm._v("bny-"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("dm/ bnyhm")]), _vm._v(" between vv. 3 and 16, undoubtedly also with an antithetical tendency: despite the mortality of the "), _c('i', [_vm._v("children")]), _vm._v(" of humanity there is hope that YHWH’s servant and their "), _c('i', [_vm._v("children")]), _vm._v(" will see revealed the glory of YHWH."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn88",
      "id": "fn88"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("By a rhetorical question—“who knows?”—the penitents confess that mankind is so sinful that none or few know the vehemence of God’s wrath against sin, or that it is as great as the fear due to him (v. 11; cf. Ps. 103:11). In response, the penitent prodigals ask God to make them know by their numbering their fleeting, precious days and, presumably, devote them to the fear of "), _c('i', [_vm._v("I AM")]), _vm._v(". Accordingly, they will gain wise hearts. Zenger comments: “It is striking that at the beginning [of the petition section], in verses 11–12, what we have is a petition not for an end to the crisis, but for knowledge or insight into the crisis.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn89",
      "id": "fn89"
    }
  }, [_vm._v("89")])]), _vm._v(" Their confession of their sin and of their spiritual blindness entails the supplicants’ repentance.")]), _vm._v(" "), _c('p', {
    staticClass: "H3",
    attrs: {
      "id": "s11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-11"
    }
  }, [_c('i', [_vm._v("Strophe A (Lament): Few Know God’s Wrath against Sin and the Fear Due Him 11")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Semantic pertinence demands that the question "), _c('i', [_vm._v("who")]), _vm._v(" demands the answer “very few at best” (Deut. 9:2; Prov. 31:10)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn90",
      "id": "fn90"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('i', [_vm._v("Knows")]), _vm._v(" denotes both the mental "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("knowledge of a fact and the visceral experiencing of that reality. The linkage between the indicative "), _c('i', [_vm._v("yôdēa"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(" (“knows,” v. 11) and the imperative "), _c('i', [_vm._v("hôda"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(" (“make us know,” v. 12) shows that God’s grace can overcome the human deprivation of knowledge. "), _c('i', [_vm._v("The strength")]), _vm._v(" indicates “the overpowering nature . . . and vehemence.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn91",
      "id": "fn91"
    }
  }, [_vm._v("91")]), _vm._v(" "), _c('i', [_vm._v("Of your anger")]), _vm._v(" (see v. 7; cf. the hendiadys "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("uzzô "), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("wəʾ")]), _vm._v("appô")]), _vm._v(" in Ezra 8:22) is a metonymy for God’s punishment against his foes who discredit his person or disobey his commands. "), _c('i', [_vm._v("And")]), _vm._v(" adds a second question. "), _c('i', [_vm._v("According to")]), _vm._v(" expresses conformity to a standard or rule. "), _c('i', [_vm._v("The fear due to you")]), _vm._v(" (see n. 12) signifies pious submission to God’s word out of fear and trust in him and entails a metonymy for hating evil (Prov. 8:13), departing from it (Prov. 3:7; 16:6), and doing what is right (Deut. 5:29)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn92",
      "id": "fn92"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('i', [_vm._v("Your wrath")]), _vm._v(" (see v. 9). Geoffrey W. Grogan explains the comparison: “As the reverential fear of God should be absolute, so is God’s wrath.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn93",
      "id": "fn93"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "H3",
    attrs: {
      "id": "s12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-12"
    }
  }, [_c('i', [_vm._v("Strophe B (Petition): To Know by Numbering Days 12")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The deficiency of the desired moral knowledge is met by acquiring that knowledge through numbering days. "), _c('i', [_vm._v("To number")]), _vm._v(" with the accusative means “to count” in order to obtain the sum total (cf. Gen. 13:16; Ps. 147:4; 2 Kgs. 12:10[11]; 2 Sam. 24:1) of "), _c('i', [_vm._v("our days")]), _vm._v(" (see vv. 4, 9, 10). The sum will diminish by one each day. The petition implies repentance for their iniquities and their spiritual blindness. Goldingay comments: “It is the counting of days in their toilsome and troubled nature that could push the community to this acknowledgment [of the strength of Yhwh’s wrathful anger] and of submission [in reverence to God]. Without it, people can live in denial and simply continue enjoying their lives without a care or a thought for God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn94",
      "id": "fn94"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('i', [_vm._v("So")]), _vm._v(" (see n. 13) is medial with reference to what has preceded,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn95",
      "id": "fn95"
    }
  }, [_vm._v("95")])]), _vm._v(" to wit, “to number our days,” not to verse 11. "), _c('i', [_vm._v("Cause . . . to know")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("asks for a double accusative of person and thing, both elided."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn96",
      "id": "fn96"
    }
  }, [_vm._v("96")]), _vm._v(" The object of person, "), _c('i', [_vm._v("us")]), _vm._v(", is readily supplied from “our days.” The only expressed object of thing is the objects of “know” in verse 11—to wit, God’s vehement anger against sin and that his anger is equal to the fear due him. The design of Moses is that by numbering their evanescent days people will become keenly aware of “the immense value of every single day,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn97",
      "id": "fn97"
    }
  }, [_vm._v("97")])]), _vm._v(" and they elevate their minds to God in heaven by detaching them from the insolent pride associated with earthly objects (Eph. 5:16; Col. 4:5). By facing the complete negation of life due to sin, the penitents pay daily attention to the other reality: life in the fear of the Eternal who is their ever-present dwelling place (see v. 1 and David’s prayer in Ps. 39:4–7[5–8]). Verse 12, says M. Wilcox, is “a lesson not in elementary arithmetic but in life-changing theology.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn98",
      "id": "fn98"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('i', [_vm._v("That")]), _vm._v(" (see n. 14) "), _c('i', [_vm._v("we may gain")]), _vm._v(" (lit. “that we may cause to come in”). "), _c('i', [_vm._v("Wise")]), _vm._v(" signifies masterful skill in living."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn99",
      "id": "fn99"
    }
  }, [_vm._v("99")])]), _vm._v(" In wisdom literature, wisdom is a matter of the heart’s disposition and is inseparable from doing what is right (cf. Prov. 1:3) and from its reward of life. Delitzsch comments: “The wise heart is the fruit which one reaps or garners in from such numbering of the days, the gain which one carries off from so constantly reminding one’s self of the end.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn100",
      "id": "fn100"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2",
    attrs: {
      "id": "s13"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#s-13"
    }
  }, [_vm._v("Stanza IV (Petitions): Relent from Anger and Bless Israel 13–17")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("“Your servants” frames the petitions (vv. 13, 16) and links the closing petitions to the opening doxology (v. 1). The penitents follow their prayer for salutary knowledge with petitions that God take pity on them (v. 13) and bless them (vv. 14–17). Weiser comments: “The hand which afflicted the wounds is alone able to heal them (cf. Hos.6.1).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn101",
      "id": "fn101"
    }
  }, [_vm._v("101")])]), _vm._v(" According to covenant theology, "), _c('i', [_vm._v("I AM")]), _vm._v(" relents from his anger when his people repent, as indicated of the generation that prays this prayer in the two preceding stanzas (cf. Prov. 28:13; Jer. 18:1–8; Jonah 4:2). Tate helpfully expresses the opinion of most commentators: “The meditation, or reflection, in verses 1–12 is the context and foundation for the petitions in verses 13–17.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn102",
      "id": "fn102"
    }
  }, [_vm._v("102")])]), _vm._v(" Kirkpatrick comments that their consolation of sorrow and their consecration of effort lies in the hope of the renewed life of the nation (Lam. 5:21), not yet in personal immortality, unlike 1 Cor. 15:58."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn103",
      "id": "fn103"
    }
  }, [_vm._v("103")])]), _vm._v(" Nevertheless, as Isaac Taylor comments, “the thought of a life eternal is here in embryo.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn104",
      "id": "fn104"
    }
  }, [_vm._v("104")])]), _vm._v(" Although they speak of their future years as “according to the years you afflicted us” and their hope is in their descendants, they nevertheless ask to be delivered from the sleep of death and mention the morning of the new age without mentioning the night. Their embryonic desire will come to birth in Jesus Christ in a way immeasurably greater than they could ask or imagine (Eph. 3:20; cf. 2 Cor. 4:17).")]), _vm._v(" "), _c('p', {
    staticClass: "H3",
    attrs: {
      "id": "s14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-14"
    }
  }, [_c('i', [_vm._v("Strophe A: Relent from Punishment 13")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('i', [_vm._v("Šûb")]), _vm._v(" (“to [re]turn” to a place [v. 3]) is used figuratively for "), _c('i', [_vm._v("turn back")]), _vm._v(" [from your anger and judgment] (vv. 3–11; see n. 15; cf. Exod. 32:12; Joel 2:14). "), _c('i', [_vm._v("I AM")]), _vm._v(" ("), _c('i', [_vm._v("yhwh")]), _vm._v(", see pp. 1–3), God’s covenant name with Israel, is used for the first time and is apt in a plea for covenant fidelity. "), _c('i', [_vm._v("How long")]), _vm._v(" elides “will your vehement anger against sin be turned against your servants?” (vv. 3–11)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn105",
      "id": "fn105"
    }
  }, [_vm._v("105")])]), _vm._v(" The rhetorical question expresses exasperation in the acute situation of death and futility long endured and invests the petition "), _c('i', [_vm._v("and take pity on")]), _vm._v(" (see n. 16) with urgency. "), _c('i', [_vm._v("Your servants")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("(see “O Lord,” v. 1) implies Israel’s conversion, for to be a servant entails Israel’s whole life being in subjection or in a subordinate position to their Master (cf. v. 1). As such, they live in (a) responsible obedience to his direction, (b) faithful dependence on his care, (c) personal intimacy of trust with him, and (d) humility before him.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('p', {
    staticClass: "H3",
    attrs: {
      "id": "s15"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#s-15"
    }
  }, [_c('i', [_vm._v("Strophe B: Confer Benedictory Blessings 14–17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The benedictory petitions to "), _c('i', [_vm._v("I AM")]), _vm._v(" consist of two couplets: (a) to satisfy them with his unfailing love and so to make them rejoice (vv. 14–15) and (b) to show his mighty work among them and so to establish their work (vv. 16–17). The two couplets are joined by the catchword “to see” (vv. 15b, 16a), supplemented by the assonance of the last two words of verse 15 ("), _c('i', [_vm._v("rā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("înû rā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("â")]), _vm._v(" “we saw disaster”) with the first word of verse 16 ("), _c('i', [_vm._v("yērā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("eh")]), _vm._v(" “let appear”). The penitents will rejoice (vv. 14–15) when the majestic saving acts of God once again appear among them.")]), _vm._v(" "), _c('p', {
    staticClass: "H4",
    attrs: {
      "id": "s16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-16"
    }
  }, [_vm._v("1. To Rejoice in God’s Unfailing Love in His Saving Deeds 14–15")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Verses 14 and 15 are connected by the catchwords “rejoice” and “days” (vv. 14b, 15a). The petition to be sated with "), _c('i', [_vm._v("I AM’s")]), _vm._v(" unfailing love (v. 14a) is supported by the motivation that “we may rejoice in all our days” (v. 14b). The motive is then reprised as an imperative in verse 15a for emphasis, and “all our days” is clarified by “according to the days you afflicted us” (v. 15b).")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("14")]), _vm._v(" "), _c('i', [_vm._v("Satisfy us")]), _vm._v(" is a request to provide the wise servants with the full and consummate measure of their expectations, needs, and desires. No distinction is intended between their physical and spiritual appetites, for they end their fleeting and futile span of days in a sigh. Their whole being hungers for "), _c('i', [_vm._v("I AM")]), _vm._v("’s unfailing love. "), _c('i', [_vm._v("In the morning")]), _vm._v(" (see v. 5b) is conventionally the time God answers prayer. It scenically depicts the bright joy of flourishing life in the new dispensation after the night of distress in the old (cf. Job 11:17; Pss. 30:5[6]; 46:5[6]; 49:14[15]; 59:16[17]; 143:8). Unlike verses 4–5, no mention is made of death at sunset. The petition contains in embryo the hope for the dawn of what will become known as “the messianic era.” "), _c('i', [_vm._v("With your unfailing love")]), _vm._v(" ("), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("ḥasdekâ")])]), _vm._v("; see Ps. 100:5). "), _c('i', [_vm._v("That we may shout [for joy] and rejoice")]), _vm._v(" ("), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("ûn"), _c('sup', [_vm._v("e")]), _vm._v("rannənâ w"), _c('sup', [_vm._v("e")]), _vm._v("niśm"), _c('sup', [_vm._v("e")]), _vm._v("ḥâ")])]), _vm._v(") probably assumes a liturgical setting, and if so, their joy gives praise to God, an enrichment of the supporting motivation. "), _c('i', [_vm._v("Rānan")]), _vm._v(" Piel, in contrast to Qal (“to rejoice”), means “to let out an entire series of "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("cries of jubilation, to rejoice.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn106",
      "id": "fn106"
    }
  }, [_vm._v("106")]), _vm._v(" It commonly occurs with "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("śāmaḥ")])]), _vm._v(" (“rejoice”; see Ps. 100:2). "), _c('i', [_vm._v("In all our days")]), _vm._v(" (see vv. 4, 9) envisions their daily experience, within the time allotted to them, of God’s unfailing love with fitting praise. Feuer comments: “"), _c('i', [_vm._v("Radak")]), _vm._v(" perceives this verse as a reference to the dawn of the messianic era, which will shine brilliantly as the morning sun. At that time, we will be sated by God’s kindness and we will never again experience any misery. Then "), _c('i', [_vm._v("we shall sing out and rejoice all our days.")]), _vm._v("”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn107",
      "id": "fn107"
    }
  }, [_vm._v("107")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("15")]), _vm._v(" Since “to rejoice” is a spontaneous response to a situation and so cannot be imposed, "), _c('i', [_vm._v("make us rejoice")]), _vm._v(" is a metonymy for the good things that prompt this emotional response. "), _c('i', [_vm._v("According to")]), _vm._v(" [i.e., as long as] "), _c('i', [_vm._v("the days")]), _vm._v(" (see v. 14b) "), _c('i', [_vm._v("you afflicted us")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn108",
      "id": "fn108"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('i', [_vm._v("According to the years")]), _vm._v(" matches the parallelism of verse 9 and presumably refers to the span of seventy and eighty years (v. 10). The gnomic psalm does not mention the forty years of wilderness affliction (see p. 35). The parallel "), _c('i', [_vm._v("we saw")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn109",
      "id": "fn109"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('i', [_vm._v("disaster")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn110",
      "id": "fn110"
    }
  }, [_vm._v("110")])]), _vm._v(" changes the perspective from God’s afflicting them to their experiencing the affliction. Moses is groping and yearning for days and years of God’s favor and expresses that hope in terms of equilibrium."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn111",
      "id": "fn111"
    }
  }, [_vm._v("111")])]), _vm._v(" Kirkpatrick paraphrases: "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("“Let the joy of restoration to Thy favour be proportioned to the depth of our humiliation.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn112",
      "id": "fn112"
    }
  }, [_vm._v("112")]), _vm._v(" "), _c('span', {
    staticClass: "charSR"
  }, [_vm._v("Ḥakham")]), _vm._v(" similarly comments: “The psalmist is alluding to the feeling of gladness that compensates for all the suffering in life.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn113",
      "id": "fn113"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "H4",
    attrs: {
      "id": "s17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#s-17"
    }
  }, [_vm._v("2. To See God’s Saving Deeds and to Establish the Israelites’ Work 16–17")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The couplet is tightly sutured by the conjunction “and,” the jussive mood, the synonyms “your work” ("), _c('i', [_vm._v("po"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _c('sup', [_vm._v("o")]), _vm._v("lekā")]), _vm._v(", v. 16a) and “our work” ("), _c('i', [_vm._v("ma"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _c('sup', [_vm._v("a")]), _vm._v("śēh yādênû")]), _vm._v(", v. 17), "), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn114",
      "id": "fn114"
    }
  }, [_vm._v("114")])]), _vm._v(" and a pun on "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("al")]), _vm._v(" (“to” and “upon”).")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("16")]), _vm._v(" The prayer in verse 16a asks for the present generation (“your servants”) to see God’s mighty deeds, and verse 16b escalates the description of those deeds, calling them “splendor,” and extends the request to benefit unrestricted future generations. "), _c('i', [_vm._v("Let appear")]), _vm._v(" (see n. 20) refers to seeing and experiencing "), _c('i', [_vm._v("I AM")]), _vm._v("’s mighty saving "), _c('i', [_vm._v("deeds")]), _vm._v(" as Moses’s generation (see “Author” above) had (e.g., the exodus, manna, quails, and the rock and at Sinai; cf. Hab. 3:2). "), _c('i', [_vm._v("Your servants")]), _vm._v(" refers to the penitent generation (see vv. 1, 6, 13), extended to their descendants in the second part of the verse. "), _c('i', [_vm._v("Your splendor")]), _vm._v(" (see n. 21) is a metonymy for its parallel, “deeds.” "), _c('i', [_vm._v("To")]), _vm._v(" (see n. 22) "), _c('i', [_vm._v("their")]), _vm._v(" [“your servants”] "), _c('i', [_vm._v("sons")]), _vm._v(" could have a synchronic sense, but in this psalm, featuring generations and time, it is diachronic.")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('b', [_vm._v("17")]), _vm._v(" God’s majesty is expanded into the “beauty of God,” conferred as an enduring presence upon them and presumably their descendants. Samuel A. Meier defines "), _c('i', [_vm._v("beauty")]), _vm._v(" ("), _c('i', [_vm._v("nō"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("am")]), _vm._v(") as a physical reality: “The intrinsic agreeableness of an object is identified by reference to the many of the five physical senses.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn115",
      "id": "fn115"
    }
  }, [_vm._v("115")])]), _vm._v(" This metonymy for "), _c('i', [_vm._v("I AM")]), _vm._v("’s experienced deeds is visualized as theophany "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("coming down to settle and "), _c('i', [_vm._v("rest upon us")]), _vm._v(" (see n. 23)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn116",
      "id": "fn116"
    }
  }, [_vm._v("116")]), _vm._v(" This beauty is an inalienable possession of "), _c('i', [_vm._v("the Lord our God")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn117",
      "id": "fn117"
    }
  }, [_vm._v("117")])]), _vm._v(" Matching verses 13–15, the psalmist reverts to the imperative “establish” in direct address. With their hands emptied of pride (see v. 10), Moses adds the final petition: "), _c('i', [_vm._v("and the work of our hands establish")]), _vm._v(" ("), _c('i', [_vm._v("kôn"), _c('sup', [_vm._v("e")]), _vm._v("nâ")]), _vm._v("). “The work of our hands” is a metonymy for their creations in arts and crafts and a potential metaphor for their social achievements. "), _c('i', [_vm._v("Kûn")]), _vm._v(" Polel means “to make established an entity already present”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn118",
      "id": "fn118"
    }
  }, [_vm._v("118")])]), _vm._v("; it connotes permanence, firmness, stability. The permanence of the renewed people’s works matches the enduring life of the renewed people (see v. 15) and stands in stark contrast to the fleeting, futile, and frustrating character of the mortal’s work under God’s wrath. "), _c('span', {
    staticClass: "charSR"
  }, [_vm._v("Ḥakham")]), _vm._v(" comments: “The psalmist’s purpose is to request that we ourselves will be privileged to eat the fruits of our toil, and that we will not be like those described in Psalm 39:7. . . , in Psalm 49:11, or in Ecclesiastes 2:1.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn119",
      "id": "fn119"
    }
  }, [_vm._v("119")])]), _vm._v(" By an exceptional repetition, yet with a change of syntax “the work of hands, establish it” expresses the strong desire that their works withstand the test of time and implicitly be enjoyed by others independently from them. Weiser comments: “Seen in the light of God what is evanescent becomes durable, what is miserable becomes glorious, and what is meaningless becomes meaningful, because everything is bathed in the light of eternity.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn120",
      "id": "fn120"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "H1b",
    attrs: {
      "id": "s005"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s5"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III. V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OICE OF THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH IN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESPONSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Throughout the ages, commentators have differed on whether the fourth book of Psalms begins with this psalm ascribed to Moses or whether Book III ends with this psalm. The church fathers considered the end of Book III to be Ps. 90[= LXX 89], while the Reformers placed the Song of Moses at the beginning of Book IV. Goldingay, along with McCann, suggests that Psalms 90–106 might be called a “Moses-book,” as Moses is mentioned several times in these psalms, but only once in Books I–III."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn121",
      "id": "fn121"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("Psalm 90 was sung in early Christian liturgy as a morning psalm, while in Jewish liturgy it had been a Sabbath psalm."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn122",
      "id": "fn122"
    }
  }, [_vm._v("122")]), _vm._v(" As a psalm reflecting upon human mortality, it has traditionally been quoted at funeral services. Isaac Watts (1674–1748) paraphrased the psalm in the well-known hymn, “O God, Our Help in Ages Past.” Later composers such as Vaughan Williams and Charles Ives have also focused on Ps. 90, “God’s dwelling place,” as a source of musical awe and contemplative peace.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The multipurpose use of the Psalms is best studied first of all in the writings of the church fathers, who were concerned not with canonical nor historical contexts but with a healing and salvific address. Athanasius and Augustine pioneered this interpretive concern.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s006"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s6"
    }
  }, [_vm._v("I. Athanasius of Alexandria (c. 295–373)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Athanasius wrote a pastoral letter to Marcellinus, who was probably a deacon or at least an urban Christian who needed to adopt an ascetic life."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn123",
      "id": "fn123"
    }
  }, [_vm._v("123")])]), _vm._v(" It probably dates from c. 367. According to the letter, Marcellinus had fallen sick but had been occupying his time in convalescence studying the Scriptures. Athanasius writes to him that singing the Psalms is indeed therapeutic. Following Plato, Athanasius believed that human beings have three faculties: reason ("), _c('i', [_vm._v("logistikon")]), _vm._v("), affections ("), _c('i', [_vm._v("thymetikon")]), _vm._v("), and passions or desires ("), _c('i', [_vm._v("epithymetikon")]), _vm._v("). Singing the words of the Psalms richly broadens those words, and the melodies enable worshipers to “love God with their whole strength and power.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn124",
      "id": "fn124"
    }
  }, [_vm._v("124")])]), _vm._v(" Harmonious singing of the Psalms makes for harmonious people. As Carol Harrison observes, “Athanasius’ description of the natural resonance which exists between the souls and the Psalms is clearly based on his conviction that both are the work of God and that both resonate in microcosm, with the measured music of his entire creation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn125",
      "id": "fn125"
    }
  }, [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Thus Athanasius speaks of the soul-healing of the Psalms. They stir our inner life deeply, as a mirror of the soul—indeed, as a mini-Bible, a synopsis of all the Old Testament Scriptures. Like a doctor making his right prescription for each medical patient, so does Athanasius use the Psalms: “If you intend to make yourself bold and the others confident in right worship, since hope placed in God brings no shame, but instead makes the soul fearless, then praise God with the expressions of Psalm 90.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn126",
      "id": "fn126"
    }
  }, [_vm._v("126")])]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s007"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s7"
    }
  }, [_vm._v("II. Augustine of Hippo (354–430)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Augustine also acknowledges the profound influence of music. But in his homily on Ps. 90, he reflects upon Moses as the pivotal biblical figure: servant of the Old Covenant and prophet of the New Covenant. He quotes the words of Jesus: “If you believed Moses, you would believe me, for he wrote about me” (John 5:46)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn127",
      "id": "fn127"
    }
  }, [_vm._v("127")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Augustine interprets v. 1, “throughout generations” (lit. “in generation and generation”) as referring to “the two generations” of the two covenants."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn128",
      "id": "fn128"
    }
  }, [_vm._v("128")])]), _vm._v(" God is the Creator of “the earth,” where humans live, and of “the mountains” where the angels dwell. Time, too, is one of God’s creations; God himself exists")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("not from any age, but before the ages. . . . There is no “was” or “will be,” in God, but only “is.” This is why God said, "), _c('i', [_vm._v("I AM WHO I AM. Thus shall you say to the children of Israel, HE WHO IS has sent me to you, and why it is said to him in a psalm, You will discard them, and so they will be changed, but you are the selfsame, and your years shall not fail")]), _vm._v(" (Exod. 3:14; Pss.101:27–28(102:26–27))."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn129",
      "id": "fn129"
    }
  }, [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("Then in verses 3–6, Augustine contrasts the transience of this life with the world to come. In what sense is Augustine using this psalm therapeutically? It’s all about Christians’ soul health as spiritual beings. Humanly, we may reach “seventy” years, but we may be blessed to reach “eighty” by being “strong” spiritually—by already living in the eternal state."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn130",
      "id": "fn130"
    }
  }, [_vm._v("130")])]), _vm._v(" Because of this spiritual "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("strength, the fierce suffering of the martyrs simply intensified the experience of the “splendor of the Lord” shining upon his faithful witnesses—something Augustine may have witnessed himself. “Faith working through love” is the unique work of "), _c('i', [_vm._v("I AM")]), _vm._v(", which the apostle tells us is “the work God wants” (John 6:29). “Thus the sole work, in which all others are comprised, is faith working itself out through love.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn131",
      "id": "fn131"
    }
  }, [_vm._v("131")])]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s008"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s8"
    }
  }, [_vm._v("III. Gregory of Nyssa (c. 332–395)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Gregory, writing between 376 and 378, like his elder brother, Basil of Caesarea, discerns musical harmony between the cosmos and the human person. As Hans Boersma puts it: “Harmony and virtue, beauty and goodness, go together with the Cappadocian Fathers.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn132",
      "id": "fn132"
    }
  }, [_vm._v("132")])]), _vm._v(" Gregory interprets the five books of the Psalms as having the “blessedness,” or aim ("), _c('i', [_vm._v("telos")]), _vm._v("), of climbing Mount Sinai in five stages, as the growth of the virtuous life. It begins in Ps. 1 with “Blessed is the man,” with all that follows being “praise unto our God.” In the next stage, in Ps. 42[41], like the doe, the soul is longing and thirsting after God. Ps. 73[72] describes the kind of contemplation that is possible in the third stage of ascent. Ps. 90[89] begins the fourth stage with Moses guiding the soul to the height that Moses himself had climbed, having “removed himself from things that are inferior and earthly.” In Ps. 107[106], the climax or mountain peak is reached, seeing a complete summation of human salvation and reaching to the final eschatological song of praise in Ps. 150."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn133",
      "id": "fn133"
    }
  }, [_vm._v("133")])]), _vm._v(" As Boersma concludes: “Music making, Bible reading, and moral living were all of a piece to the church fathers.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn134",
      "id": "fn134"
    }
  }, [_vm._v("134")])]), _vm._v(" The Psalms superbly demonstrate this unity.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s009"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s9"
    }
  }, [_vm._v("IV. Martin Luther (1483–1546)")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("When we come to the Reformation, however, Ps. 90 is treated much more polemically. Luther’s passionate pronouncement was that Moses had to be Moses in this psalm.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("Luther, in one of his last lectures on the Psalms before beginning his massive commentary on the book of Genesis, interprets Ps. 90 as a lament psalm. He had begun his teaching on “the seven penitential psalms"), _c('i', [_vm._v("”")]), _vm._v(" in 1517, but now, toward the end of his life in 1535, his theme is “the lament psalms.” He had been attached to the Psalms all his life, beginning in 1505 when he became an Augustinian friar.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("Luther argues that Moses only composed one psalm, recognizing his authorship was supported not only by “the title, but also the language itself, the subject matter, and the whole theology of the Psalm.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn135",
      "id": "fn135"
    }
  }, [_vm._v("135")]), _vm._v(" In his last lecture series on the Psalms, in 1535, Luther argued, as Dennis Ngien summarizes, “Moses taught us the proper way of reading the Scriptures (2 Tim. 2:15), in which one must deal with arrogant and smug sinners in one way (i.e. by the law) but in an entirely different way with those have been already terrified (i.e. by the Gospel).”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn136",
      "id": "fn136"
    }
  }, [_vm._v("136")])]), _vm._v(" The prime office of Moses, the archetype, was to be the inseparable companion of Holy Scripture, fulfilling his special office as “a minister of death, sin, and damnation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn137",
      "id": "fn137"
    }
  }, [_vm._v("137")])]), _vm._v(" No doubt Luther also saw this as his own office in the context of the Reformation, so he has a strong partiality for Moses, dwelling on this theme for most of his lecture! God’s dwelling place and grace are the same thing for Luther, and “both creation and condemnation, contradictory activities, are done by the one and same God. . . . Just as life comes as a result of God’s design, so death occurs as the result of God’s wrath.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn138",
      "id": "fn138"
    }
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Luther’s pessimism, he sees even the life of Methuselah, who lived a thousand years, to be as nothing with God (cf. Ps. 90:4). With sin in our lives, we live like lepers, yet the worst calamity is when we are unaware of our mortality! As with our secular society today, Luther saw that the vast majority of human beings in his time were practical atheists, going about their daily tasks as though there were “no death, and for that matter, no God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn139",
      "id": "fn139"
    }
  }, [_vm._v("139")])]), _vm._v(" But Moses, according to Luther, found consolation in God, who “before the mountains were born, and you brought to birth the earth and the world,” is God who creates "), _c('i', [_vm._v("ex nihilo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Thus for Luther, effective pastoral care is nothing other than the ministry of both law and gospel to cause us to repent in lament for sins. "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("In this sense, God is “the God of lamentations.” He causes lament, yet he cures the lamenting soul. It is Satan who causes us to lament without repentance, with no hope in our utter despair. Early in his life, Luther began to formulate his “theology of the cross,” as “negative theology.” But unlike Dionysius, who uses negatives to make affirmations and to achieve union with God, Luther finds God in weakness and suffering, not in majesty and glory. Thus the petition of Moses in v. 16, “Let your deeds appear to your servants and your splendor to their children,” points to the advent of Christ in the flesh."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn140",
      "id": "fn140"
    }
  }, [_vm._v("140")]), _vm._v(" Negation, then, is not found through our logical conclusions based on natural knowledge but through the cross; not through a mystical ascent to God but through the sacred text itself. The experience of God is not found in the Dionysian darkness but in the life of the believer who has the text in the heart. As Gerhard Forde observes, the question of what God might do or not do is already answered in what he actually does and has done."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn141",
      "id": "fn141"
    }
  }, [_vm._v("141")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("After it has been thoroughly terrified, Luther advises the soul to sigh to God for mercy. It is an exercise like "), _c('i', [_vm._v("compunctio")]), _vm._v(", which we have discussed in our previous commentaries."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn142",
      "id": "fn142"
    }
  }, [_vm._v("142")])]), _vm._v(" Sighing is likewise a deep-felt emotion (“sighs too deep for words,” Rom. 8:26, NRSV) that has a childlike authenticity, naivety, honesty, and dependence, all of which delight the heart of God. It is where God has his dwelling place within our hearts."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn143",
      "id": "fn143"
    }
  }, [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The conclusion is the opposite to where the petitioner started. God is no longer “the problem.” Wrath has been transformed into mercy, darkness and illness into light and health. Quoting v. 14, “Satisfy us in the morning with your unfailing love that we may shout for joy and rejoice in all our days,” Luther concludes that we may now enter into God’s “oceanic mercy.” In the vastness of this experience, we voice the final petition: “Let the beauty of "), _c('i', [_vm._v("I AM")]), _vm._v(" our God rest upon us, and the work of our hands establish for us; and the work of our hands, establish it” (Ps. 90:17)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn144",
      "id": "fn144"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Many other commentators have followed Luther in his commentary on this psalm, but we conclude with him, because his meditation is climactic!")]), _vm._v(" "), _c('p', {
    staticClass: "H1b",
    attrs: {
      "id": "s010"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s10"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" IV. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCLUSION")])])]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s011"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s11"
    }
  }, [_vm._v("I. Canonical Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("According to Gerald Wilson, there is a historical movement reflected in the arrangement of the Psalter: Books IV and V are a response to Psalm 89, a psalm in which the issues of the failed Davidic monarchy and the crisis of the Babylonian exile are addressed (see pp. 15–16)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn145",
      "id": "fn145"
    }
  }, [_vm._v("145")])]), _vm._v(" Accordingly, Book IV (Psalms 90–106) answers the crisis of the Babylonian exile by redirecting reliance on an earthly monarchy to an appreciation of God’s eternal kingship,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn146",
      "id": "fn146"
    }
  }, [_vm._v("146")])]), _vm._v(" from reliance on the earthly temple to reliance upon God himself. J. Clinton McCann argues: “Book IV can be characterized as a Moses-book, and in response to the crisis of exile and its aftermath, it offers the ‘answer’ that pervades the Psalter and forms its theological heart: God reigns!”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn147",
      "id": "fn147"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is an alternate eternal reality—the kingdom of God—that intersects with the sordid political reality. The two have not yet become one kingdom, but someday, in Jesus Christ, they will become one. That intersection began afresh with the advent of Jesus Christ. In his first advent, he bore God’s wrath for the sins of his people (vv. 3–10) and learned obedience through his sufferings (vv. 11–12); in his second advent, he will fill them with eternal joy (vv. 13–17). Jerusalem and its carnal temple failed, but Christ’s church will prevail. Ultimately the kingdom of God, the church, under the reign of Jesus Christ, the anointed King, will fill the new heaven and earth.")]), _vm._v(" "), _c('p', {
    staticClass: "H1",
    attrs: {
      "id": "s012"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch2s12"
    }
  }, [_vm._v("II. Message")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("The confidence that Israel’s God is always his people’s dwelling place gives the prodigal penitents space to lament that they wither as quickly as grass due to God’s wrath against their sin and to find by their faith in him what the Jerusalem temple previously provided: peace and protection. Pity the homeless prodigal. Though few people know the verity that God’s wrath is commensurate "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("with the fear due him, the penitent prodigals, humbled and yet hopeful, ask God to cause them to know this by numbering their days and so giving them wise hearts. Thus enlightened, they petition "), _c('i', [_vm._v("I AM")]), _vm._v(" to confer upon them a new dispensation both of the joy of salvation in days and years commensurate with their affliction and of enduring work as his majestic deeds of salvation—in which they participate—once again appear among them. The most merciful God hears the prayer of the humble and does not despise their plea; rather, in the resurrected and eternal Jesus Christ, he answers them abundantly more than they dared to think or imagine. Yes, when he hides his face, we are dismayed and return to dust, but when he sends forth his life-giving Spirit, we renew the face of the ground both now and forevermore.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". LXX and a few Heb. MSS read "), _c('i', [_vm._v("m"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("wz")]), _vm._v(" (“place of safety”/ “refuge”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")]), _vm._v(". LXX reads "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("al")]), _vm._v(" instead of "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("ēl")]), _vm._v(" in v. 2 in combination with "), _c('i', [_vm._v("tāšēb")]), _vm._v(" in v. 3, read as a jussive = “From eternity to eternity you are. Do not turn back.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "rfn3"
    }
  }, [_vm._v("3")]), _vm._v(". The short prefix conjugation ("), _c('i', [_vm._v("IBHS")]), _vm._v(", §31.1h) may be due to its being as far as possible from the "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("athnaḥ")])]), _vm._v(" (GKC, 109k).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "rfn4"
    }
  }, [_vm._v("4")]), _vm._v(". Or, “you sweep them away as in a flood.” "), _c('i', [_vm._v("Zrm")]), _vm._v(" may be a homonym. According to G. R. Driver (“Some Hebrew Medical Expressions,” "), _c('i', [_vm._v("ZAW")]), _vm._v(" 65 [1953], 259), "), _c('i', [_vm._v("zrm")]), _vm._v(" is cognate to an Arabic root meaning “to interrupt, to stop.” "), _c('i', [_vm._v("HALOT")]), _vm._v(" glosses it: “to make an end of life.” In this verse, however, it has traditionally been interpreted as "), _c('i', [_vm._v("zrm")]), _vm._v(" II Polel “to unload clouds of water accompanied by thunder” (cf. Ps. 77:17[18]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "rfn5"
    }
  }, [_vm._v("5")]), _vm._v(". Lit. “they are sleep.” The predication of an abstract noun to a person signifies that the subject is totally characterized by the abstraction: e.g., “I am peace” = “I am wholly given to peace” (Ps. 120:7); “I am prayer” = “I am totally given to prayer” (Ps. 109:4).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "rfn6"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('i', [_vm._v("HALOT")]), _vm._v(" glosses "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("yaḥălōp")])]), _vm._v(" by “to fly along, to pass over, away,” but BDB glosses it “to sprout anew.” The sense of “change” informs all the uses of the lexeme "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("ḥālap")])]), _vm._v(". LXX and Vulg. invest it with sense of “pass away.” But since the grass of the morning is contrasted with the withered grass of the evening, the more suitable sense is with respect to the beginning of the movement, and so with grass it means “to come anew, be renewed.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "rfn7"
    }
  }, [_vm._v("7")]), _vm._v(". GKC (124e) classifies "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("gəbûrôt")])]), _vm._v(" in Job 41:4, and presumably so "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("gəbûrōt")])]), _vm._v(" in Ps. 90:10, as an intensive plural—“(exceptional) strength”—but it could be an abstract plural ("), _c('i', [_vm._v("IBHS")]), _vm._v(", §7.4.2a).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8",
      "id": "rfn8"
    }
  }, [_vm._v("8")]), _vm._v(". Both the text and meaning of "), _c('i', [_vm._v("rohbām")]), _vm._v(" are uncertain. Many emend the text to "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("r"), _c('sup', [_vm._v("e")]), _vm._v("ḥābām")])]), _vm._v(" (“their span,” so NRSV and NIV 1984) or read with help of versions "), _c('i', [_vm._v("rubbām")]), _vm._v(" (“multitude of them”). LXX reads “the greater part of them” (see NAB: “most of them”); Vulg., “and what is more of them”; Tg., “most of them.” But MT cannot be explained away, whereas "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("r"), _c('sup', [_vm._v("e")]), _vm._v("ḥābām")])]), _vm._v(" or "), _c('i', [_vm._v("rubbām")]), _vm._v(" can be readily explained as facilitating readings. The noun "), _c('i', [_vm._v("rōhab")]), _vm._v(" occurs only here, and its verbal equivalent occurs twice in Qal"), _c('i', [_vm._v(",")]), _vm._v(" meaning “to storm”/“to behave violently”/“to act insolently”: of youth against the elder (Isa. 3:5); of the debtor against the creditor (Prov. 6:3). (The noun "), _c('i', [_vm._v("rahab")]), _vm._v(" refers to a mythical monster, “Surger,” and “plays upon the restlessness and crashing of the sea.”) The singular "), _c('i', [_vm._v("rōhab")]), _vm._v(" is collective.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9",
      "id": "rfn9"
    }
  }, [_vm._v("9")]), _vm._v(". K. H. Bernhardt ("), _c('i', [_vm._v("TDOT")]), _vm._v(", 1:145, s.v. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("āwen")]), _vm._v(") comments: “Psalm 90:10 sees in "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("aven")]), _vm._v(" the ultimately vain toil of life, determined by God for man in general.” This is consistent with the following clause: “for they pass away quickly.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10",
      "id": "rfn10"
    }
  }, [_vm._v("10")]), _vm._v(". The subject of masc. sg. "), _c('i', [_vm._v("gāz")]), _vm._v(" is "), _c('i', [_vm._v("rōhab")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11",
      "id": "rfn11"
    }
  }, [_vm._v("11")]), _vm._v(". The gloss of unique "), _c('i', [_vm._v("hîš")]), _vm._v(" as “quickly” is based on the root "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("ḥûš")])]), _vm._v(": “to hasten, make haste.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12",
      "id": "rfn12"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("Yirʾātəkā")])]), _vm._v(" is usually construed as an objective genitive (“the fear of you”), an assertion of a fact; but the rhetorical question suggests it would be better glossed as a genitive of advantage (“the fear due to you,” "), _c('i', [_vm._v("IBHS")]), _vm._v(", §9.5.2e).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13",
      "id": "rfn13"
    }
  }, [_vm._v("13")]), _vm._v(". BDB (p. 485, s.v. "), _c('i', [_vm._v("kēn")]), _vm._v(") glosses "), _c('i', [_vm._v("kēn")]), _vm._v(" by “"), _c('i', [_vm._v("so")]), _vm._v(" (usu., as has been described or commanded, with ref. to what has preceded), mostly of manner.” Accordingly, the meaning is “in numbering our days, in this way teach us to know.” Moreover, according to the syntax of the Masoretic accents, "), _c('i', [_vm._v("kēn")]), _vm._v(" (“so, thus”) modifies "), _c('i', [_vm._v("hôda"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(" (“cause to know”), not "), _c('i', [_vm._v("limnôt")]), _vm._v(" (“to count”). In sum, the Hebrew text rules out the translation “so to number our days teach [us]” ("), _c('i', [_vm._v("pace")]), _vm._v(" KJV, ASV, JPS, NRSV, ESV). Also, "), _c('i', [_vm._v("kēn")]), _vm._v(" does not signify purpose, disqualifying the translation “teach us so that we may know” ("), _c('i', [_vm._v("pace")]), _vm._v(" NAB, NIV, NJB, CSB, NET). "), _c('i', [_vm._v("HALOT")]), _vm._v(" (1:482, s.v. "), _c('i', [_vm._v("kēn")]), _vm._v(" I) interprets "), _c('i', [_vm._v("kēn")]), _vm._v(" as an adjective (= “to know [what is] correct/right/accurate”?), but in the cited parallels, "), _c('i', [_vm._v("kēn")]), _vm._v(" follows the verb it modifies and is not medial (see Judg. 12:6; 21:14; 1 Sam. 23:17; cf. Amos 5:14). No English translation, to my knowledge, accurately represents the Hebrew text. The object of “to know” must be supplied from v. 11, namely “"), _c('i', [_vm._v("I AM")]), _vm._v("’s anger” (see commentary).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14",
      "id": "rfn14"
    }
  }, [_vm._v("14")]), _vm._v(". Semantically, a logical consequence (so also BDB, p. 99, s.v. "), _c('i', [_vm._v("bô"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")])]), _vm._v(" Hiphil, §1g).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15",
      "id": "rfn15"
    }
  }, [_vm._v("15")]), _vm._v(". “Turn back from judgment” (see BDB, p. 997, s.v. "), _c('i', [_vm._v("šûb")]), _vm._v(", §6f). Traditionally, “return” suggests that "), _c('i', [_vm._v("I AM")]), _vm._v(" has abandoned his people, but that notion does not comport well with the confession that "), _c('i', [_vm._v("I AM")]), _vm._v(" is the penitents’ dwelling place forever. This difference in interpretation is as old as the rabbis. Avrohom Chaim Feuer ("), _c('i', [_vm._v("Tehillim: A New Translation with a Commentary Anthologized from Talmudic, Midrashic and Rabbinic Sources,")]), _vm._v(" trans. Avrohom Chaim Feuer in collaboration with Nosson Scherman [Brooklyn: Mesorah, 1982], 1.129) notes the difference in the rabbinic literature: “Turn back Your anger (Rashi) . . . "), _c('i', [_vm._v("How long")]), _vm._v(" will You abandon us? (Radak).”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16",
      "id": "rfn16"
    }
  }, [_vm._v("16")]), _vm._v(". Elsewhere "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("nḥm")])]), _vm._v(" Niphal with "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("l")]), _vm._v(" governing a personal noun means “to be consoled/comforted” (see 2 Sam. 13:39; Jer. 31:15; Ezek. 32:31), but that sense is inappropriate in Psalm 90:13. Most English versions agree with BDB (p. 637, s.v. "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("nḥm")])]), _vm._v(", §1: “be moved to pity, have compassion”) and gloss the collocation “have pity on” or the like (see “Exegesis”). Marvin E. Tate ("), _c('i', [_vm._v("Psalms 51–100")]), _vm._v(", WBC 20 [Dallas: Word, 1990], 436n13b) rejects “have pity/compassion” because, following Dale Patrick (“The Translation of Job 42:6,” "), _c('i', [_vm._v("VT")]), _vm._v(" 26 [1976]: 324–27), “when it [the verb] is used with "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("l")]), _vm._v(", it regularly means ‘to change one’s mind about something planned’ ” (i.e., “relent”/”regret”; cf. Jer. 18:8; 26:3, 13, 19; Joel 2:13; Jonah 3:10; 4:2; Deut. 32:36). But, as noted by H.-J. Stoebe ("), _c('i', [_vm._v("TLOT")]), _vm._v(", 2:738, s.v. "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("nḥm")])]), _vm._v(" Piel) that is true only when the preposition "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("l")]), _vm._v(" governs an impersonal object, usually "), _c('i', [_vm._v("rā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("â")]), _vm._v(" (“Yahweh regretted/relented from the threatened disaster”). This may also be true in Ezek. 14:22, but most English versions gloss it there as “be consoled/comforted.” If the object is personal, a further distinction, not noted by Stoebe, must be made: to wit, “to feel pain for oneself or for others.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17",
      "id": "rfn17"
    }
  }, [_vm._v("17")]), _vm._v(". The gloss “on” obfuscates the meaning of the Hebrew, for it appears to be a necessary addition to introduce the object of “take pity/pity someone.” "), _c('i', [_vm._v("HALOT")]), _vm._v(" invests "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("al")]), _vm._v(" with the meaning “because,” but more probably it means “for the sake of” (BDB, p. 754, s.v. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("l")]), _vm._v(", §1.f.[c]; cf. Ps. 44:22[23]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18",
      "id": "rfn18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('i', [_vm._v("Waw")]), _vm._v(" with the cohortative after the imperative signifies purpose (see GKC, 108d; "), _c('i', [_vm._v("IBHS")]), _vm._v(", §34.5.2b).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19",
      "id": "rfn19"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('i', [_vm._v("Pō"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("al")]), _vm._v(" is construed as a collective singular.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20",
      "id": "rfn20"
    }
  }, [_vm._v("20")]), _vm._v(". In the petition stanza and in conjunction with the initial jussive "), _c('i', [_vm._v("wîhî")]), _vm._v(" (“and let be,” v. 17), "), _c('i', [_vm._v("yērā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("eh")]), _vm._v(" is best construed as a non-apocopated jussive (cf. Gen. 1:9).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21",
      "id": "rfn21"
    }
  }, [_vm._v("21")]), _vm._v(". The LXX mistakenly repoints text as "), _c('i', [_vm._v("hadrēk")]), _vm._v(" “direct,” a facilitating reading for a figure of speech. The meaning “vision/revelation/apparition” for "), _c('i', [_vm._v("hādār")]), _vm._v(" is widely adopted on the basis of an Ugaritic cognate. But "), _c('i', [_vm._v("hādār")]), _vm._v(" in numerous instances in the Hebrew Bible consistently means “splendor” and here forms an excellent parallel to “works” (see Ps. 96:9; p. 166n2).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22",
      "id": "rfn22"
    }
  }, [_vm._v("22")]), _vm._v(". "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("Al")]), _vm._v(" may have the same dative sense as "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("el")]), _vm._v(" (BDB, p. 758, s.v. "), _c('i', [_vm._v("‘l")]), _vm._v(", §8), though this use is found mostly in postexilic Hebrew.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23",
      "id": "rfn23"
    }
  }, [_vm._v("23")]), _vm._v(". J. D. Levenson (“A Technical Meaning for N‘M in the Hebrew Bible,” "), _c('i', [_vm._v("VT")]), _vm._v(" 35 [1985]: 61–67) hypothesizes the word here translated “beauty,” "), _c('i', [_vm._v("nō"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("am")]), _vm._v(", in Pss. 4:6–7; 16:5–6, 11; and 90:16–17 takes on a connection with “an affirmative response to an act of augury.” His arguments include: a) “ ‘beauty’ [in Ps. 27:4] . . . seems excessively abstract”; b) "), _c('i', [_vm._v("hādār")]), _vm._v(" means “a revelation” of some sort of deed; c) “the light of God’s face” in Ps. 4:6 refers to “a theophanic fire employed as an affirmative omen”; d) an Akkadian parallel in an Old Babylonian divination text means “give a clear answer”; e) “May you establish” in the parallel in Ps. 90:17 should be rendered as “may you affirm, approve, say ‘yes’ to”; f) the root "), _c('i', [_vm._v("n"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("m")]), _vm._v(" in Ps. 16:5–6 occurs explicitly in association with augury; g) following a preposition, “pleasant places” in Ps. 16:11 yields no sense: “The traditional rendering ["), _c('i', [_vm._v("n"), _c('sup', [_vm._v("e")]), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("īmôt")]), _vm._v("] ‘pleasures [in his right hand]’ is ‘an oddly abstract image’ ”; h) in 2 Sam. 23:1; Num. 24:3, 15; and Prov. 30:1, “it would seem . . . the word ["), _c('i', [_vm._v("n"), _c('sup', [_vm._v("e")]), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("um haggeber")]), _vm._v("] means . . . ‘a person granted an affirmative omen.” These arguments are not convincing: a) A metonymy such as “beauty” for the thing itself is common in Hebrew poetry; b) “splendor,” the certain meaning of "), _c('i', [_vm._v("hādār")]), _vm._v(", is semantically pertinent; c) “the light of God’s face” commonly refers to God’s favor, not to theophanic fire; d) the Akkadian parallel is a different word; e) "), _c('i', [_vm._v("kûn")]), _vm._v(" Polel normally means “establish” and makes perfectly good sense, especially after the lament that their achievements are futile; f) in Ps. 16:5, David is using figurative language, and a metonymy after a preposition is not unsensible; g) a metonymy for the sum of pleasures at the exalted honor of God’s right hand is not odd; h) "), _c('i', [_vm._v("n"), _c('sup', [_vm._v("e")]), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("um haggeber")]), _vm._v(" more probably refers simply to prophetic speech. In sum, Levenson’s arguments for investing “beauty” with a technical sense are smoke and mirrors. He misunderstands or minimizes figurative language in Hebrew poetry and introduces into Old Testament theology the notion of omens by other signs than the Urim and Thummim that are housed next to the heart of the high priest.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_vm._v("Allowing "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("al (“")]), _vm._v("upon”) its normal sense, the pregnant preposition, as often occurs in Hebrew poetry, implies an elided verb of motion, such as “settle”/“rest” (see "), _c('i', [_vm._v("IBHS")]), _vm._v(", §11.4d).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24",
      "id": "rfn24"
    }
  }, [_vm._v("24")]), _vm._v(". Bruce Vawter (“Postexilic Prayer and Hope,” "), _c('i', [_vm._v("CBQ")]), _vm._v(" 37 [1975]: 460–70, esp. n. 5) wrongly says “vs 17b [is] an obvious dittography.” Vv. 17a and b are saying different things (see exposition).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25",
      "id": "rfn25"
    }
  }, [_vm._v("25")]), _vm._v(". Derek Kidner, "), _c('i', [_vm._v("Psalms 73–150")]), _vm._v(", TOTC (Downers Grove, IL: IVP Academic, 2009), 359.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26",
      "id": "rfn26"
    }
  }, [_vm._v("26")]), _vm._v(". Robert Alter, "), _c('i', [_vm._v("The Book of Psalms: A Translation and Commentary")]), _vm._v(" (New York: Norton, 2007), 318.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27",
      "id": "rfn27"
    }
  }, [_vm._v("27")]), _vm._v(". Marvin E. Tate ("), _c('i', [_vm._v("Psalms 51–100")]), _vm._v(", WBC 20 [Dallas: Word, 1990], 439) agrees with von Rad that a scribe or sage composed the psalm for the pious in postexilic communities because it is an atypical communal lament (cf. Pss. 44, 60, 74, 79, 80, 83, 106, 137): to wit, God does not hide himself; there is no complaint about national enemies nor cries of immediate distress and pleas for God to deliver. However, the prophets, of whom Moses was one, frequently pictured God as an enemy. Amos asked God to change his mind, to relent from his threatening doom (Amos 7:2). So there is good reason to think that Moses would depict God as an enemy (see Deut. 32:20–35) and ask him to relent (see Deut. 32:36–43). Like all prayers in the Bible, it is to be overheard and studied by the pious.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28",
      "id": "rfn28"
    }
  }, [_vm._v("28")]), _vm._v(". Ecclesiastes, however, unlike Psalm 90, neither attributes the trouble and toil of this life to sin nor petitions God for salvation from them.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29",
      "id": "rfn29"
    }
  }, [_vm._v("29")]), _vm._v(". Gerhard von Rad, "), _c('i', [_vm._v("God’s Work in Israel")]), _vm._v(", trans. John H. Marks (Nashville: Abingdon, 1980), 218.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30",
      "id": "rfn30"
    }
  }, [_vm._v("30")]), _vm._v(". Phyllis Trible, “Wrestling with Words, Limping to Light,” in "), _c('i', [_vm._v("Why I (Still) Believe")]), _vm._v(", ed. John Byron and Joel N. Lohr (Grand Rapids: Zondervan, 2015), 233.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31",
      "id": "rfn31"
    }
  }, [_vm._v("31")]), _vm._v(". By form and rhetorical criticism and semantics, a psalm is analyzed into stanzas, strophes and units. The psalm is the house; the stanzas are its major portions, like upstairs and downstairs; strophes are its rooms; and units are parts of a room, like ceilings and floors. As is common, in Ps. 90 these divisions are quatrains, couplets (i.e., two verses or versets), apart from v. 13. The unified invocation, lament and hinge consist of seven couplets (vv. 1b–2, 3–4, 5–6, 7–8, 9–10, 10a–10b, 11–12), and the petitions for salvation consist of three strophes with two couplets (vv. 13, 14–15, 16–17).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32",
      "id": "rfn32"
    }
  }, [_vm._v("32")]), _vm._v(". Konrad Schaefer, "), _c('i', [_vm._v("Psalms")]), _vm._v(", Berit Olam (Collegeville, MN: Liturgical Press, 2001), 226f.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33",
      "id": "rfn33"
    }
  }, [_vm._v("33")]), _vm._v(". Moses is called “the man of God” (Ps. 90:1) in the introduction to his blessing at the time of his death (Deut. 33:1). The psalm begins “you are a dwelling place,” where Moses’s blessing ended (Deut. 33:27 ["), _c('i', [_vm._v("mā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("ôn")]), _vm._v(" and "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("məʿōnâ")])]), _vm._v(" are a gender doublets]). "), _c('i', [_vm._v("Yālad")]), _vm._v(" and "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("ḥûl")])]), _vm._v(" Polel occur together in v. 2 and Deut. 32:18; "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("yəmôt")])]), _vm._v(" occurs only in v. 15 and Deut. 32:7, where also "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("dôr-wədôr")])]), _vm._v(" occurs (see v. 1).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34",
      "id": "rfn34"
    }
  }, [_vm._v("34")]), _vm._v(". F. Delitzsch, "), _c('i', [_vm._v("Psalms,")]), _vm._v(" trans. Francis Bolton, Keil and Delitzsch Commentary on the Old Testament 5 (London: T&T Clark, 1866–91; repr., Peabody, MA: Hendrickson, 1996), 593.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35",
      "id": "rfn35"
    }
  }, [_vm._v("35")]), _vm._v(". Gerhard von Rad, "), _c('i', [_vm._v("God’s Work in Israel")]), _vm._v(" (Nashville: Abingdon, 1980), 212.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36",
      "id": "rfn36"
    }
  }, [_vm._v("36")]), _vm._v(". So "), _c('i', [_vm._v("Zondervan TNIV Study Bible")]), _vm._v(", ed. Barker, Stek, Youngblood (Grand Rapids: Zondervan, 2006), 943.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37",
      "id": "rfn37"
    }
  }, [_vm._v("37")]), _vm._v(". Tate, "), _c('i', [_vm._v("Psalms 51–100")]), _vm._v(", 437f.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38",
      "id": "rfn38"
    }
  }, [_vm._v("38")]), _vm._v(". H.-J Kraus, "), _c('i', [_vm._v("Psalmen II")]), _vm._v(", BKAT 15 (Neukirchen: Erziehungsverein, 1960), 627–33.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39",
      "id": "rfn39"
    }
  }, [_vm._v("39")]), _vm._v(". Mitchell Dahood, "), _c('i', [_vm._v("Psalms II")]), _vm._v(", AB 17 (New York: Doubleday, 1968), 322.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40",
      "id": "rfn40"
    }
  }, [_vm._v("40")]), _vm._v(". Walter Brueggemann, "), _c('i', [_vm._v("The Message of the Psalms")]), _vm._v(", Augsburg Old Testament Studies (Minneapolis: Augsburg, 1984), 110.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn41",
      "id": "rfn41"
    }
  }, [_vm._v("41")]), _vm._v(". D. N. Freedman, “Who Asks (or Tells) God to Repent?” "), _c('i', [_vm._v("BRev")]), _vm._v(" 1, no. 4 (1985): 56–59.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn42",
      "id": "rfn42"
    }
  }, [_vm._v("42")]), _vm._v(". Beth L. Tanner, "), _c('i', [_vm._v("The Book of Psalms through the Lens of Intertextuality")]), _vm._v(", StBibLit 26 (New York: Peter Lang, 2001), 85–107, esp. 98.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn43",
      "id": "rfn43"
    }
  }, [_vm._v("43")]), _vm._v(". Gerald Sheppard, “Theology and the Book of Psalms,” "), _c('i', [_vm._v("Int")]), _vm._v(" 46 (1992): 143–55, esp. 151.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn44",
      "id": "rfn44"
    }
  }, [_vm._v("44")]), _vm._v(". Bruce K. Waltke with Charles Yu, "), _c('i', [_vm._v("An Old Testament Theology")]), _vm._v(" (Grand Rapids: Zondervan, 2007), 321–32.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn45",
      "id": "rfn45"
    }
  }, [_vm._v("45")]), _vm._v(". The juridical background of "), _c('i', [_vm._v("pll")]), _vm._v(", the root of "), _c('i', [_vm._v("t"), _c('sup', [_vm._v("e")]), _vm._v("pillâ")]), _vm._v(", can be observed in the nouns "), _c('i', [_vm._v("pālîl")]), _vm._v(" (“judgment,” “an estimation requiring a judgment”; see Exod. 21:22; Deut. 32:31; Job 31:11) and "), _c('i', [_vm._v("p"), _c('sup', [_vm._v("e")]), _vm._v("lîlâ")]), _vm._v(" (“decision”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn46",
      "id": "rfn46"
    }
  }, [_vm._v("46")]), _vm._v(". H. P. Stähli, "), _c('i', [_vm._v("TLOT")]), _vm._v(", 2:992, s.v. "), _c('i', [_vm._v("pll")]), _vm._v(" Hithpael.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn47",
      "id": "rfn47"
    }
  }, [_vm._v("47")]), _vm._v(". The collocation "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("îš hā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _c('sup', [_vm._v("e")]), _vm._v("lōhîm")]), _vm._v(" occurs 76 times and always refers to a prophet: Samuel (1 Sam. 9:6–10); Elijah (2 Kgs. 1:9–13); Elisha (2 Kgs. 4:7, 9, 16ff.); and, most often, Moses (Deut. 33:1; Josh. 14:6; 1 Chr. 23:14; 2 Chr. 30:16; Ezra 3:2). In the Pentateuch, Moses is called “the man of God” only at the time of his death (Deut. 33:1). In Jer. 35:4, referring to Hanan, “the Targum translates the ‘man of God’ by ‘the prophet of the Lord’ to signify a true prophet of YHWH” (Jack R. Lundbom, "), _c('i', [_vm._v("Jeremiah 21–36: A New Translation with Introduction and Commentary")]), _vm._v(", AB [New York: Doubleday, 2004], 575, citing Hayward and P. Churgin).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn48",
      "id": "rfn48"
    }
  }, [_vm._v("48")]), _vm._v(". Pierre Auffret, “Essai sur la structure litteraire du Psaume 90,” "), _c('i', [_vm._v("Bib")]), _vm._v(" 61 (1980): 262–76, esp. 63. But Auffret pairs "), _c('i', [_vm._v("m"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("wn")]), _vm._v(", not "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("dny")]), _vm._v(", with "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("l")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn49",
      "id": "rfn49"
    }
  }, [_vm._v("49")]), _vm._v(". Craig C. Broyles, "), _c('i', [_vm._v("Psalms")]), _vm._v(", NIBCOT (Peabody, MA: Hendrickson, 1999), 359.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn50",
      "id": "rfn50"
    }
  }, [_vm._v("50")]), _vm._v(". "), _c('i', [_vm._v("IBHS")]), _vm._v(", §7.4.3e.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn51",
      "id": "rfn51"
    }
  }, [_vm._v("51")]), _vm._v(". The possible gloss, “You are . . . ,” would not represent the past well.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn52",
      "id": "rfn52"
    }
  }, [_vm._v("52")]), _vm._v(". Waltke, "), _c('i', [_vm._v("An Old Testament Theology")]), _vm._v(", 321–32.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn53",
      "id": "rfn53"
    }
  }, [_vm._v("53")]), _vm._v(". Brueggemann, "), _c('i', [_vm._v("Message of the Psalms")]), _vm._v(", 111")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn54",
      "id": "rfn54"
    }
  }, [_vm._v("54")]), _vm._v(". Philip Sumpter, "), _c('i', [_vm._v("The Substance of Psalm 24")]), _vm._v(": "), _c('i', [_vm._v("An Attempt to Read Scripture after Brevard Childs")]), _vm._v(" (London: Bloomsbury T&T Clark, 2015), 97.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn55",
      "id": "rfn55"
    }
  }, [_vm._v("55")]), _vm._v(". Christopher J. H. Wright, "), _c('i', [_vm._v("NIDOTTE")]), _vm._v(", 4:273, s.v. "), _c('i', [_vm._v("tēbēl")]), _vm._v(". Poets represent the "), _c('i', [_vm._v("tēbēl")]), _vm._v(" as set upon foundations (1 Sam. 2:8) and speak of its inhabitants (Isa. 18:3; 26:9, 18; Pss. 24:1; 33:8; Lam. 4:12), its fruit (Isa. 34:1), its fullness (Ps. 50:12), and all that is in it (Ps. 89:11[12]). In draught, it withers (Isa. 24:4). The king of Babylon transformed it into an uninhabitable wilderness (Isa. 14:17), and whoever is banished from it perishes (Job 18:18).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn56",
      "id": "rfn56"
    }
  }, [_vm._v("56")]), _vm._v(". E. Jenni, "), _c('i', [_vm._v("TLOT,")]), _vm._v(" 2:854–62, s.v. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("ôlām")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn57",
      "id": "rfn57"
    }
  }, [_vm._v("57")]), _vm._v(". Artur Weiser, "), _c('i', [_vm._v("The Psalms")]), _vm._v(", OTL (Philadelphia: Westminster, 1962), 597.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn58",
      "id": "rfn58"
    }
  }, [_vm._v("58")]), _vm._v(". A. F. Kirkpatrick, "), _c('i', [_vm._v("The Book of Psalms")]), _vm._v(" (1902; repr., Grand Rapids: Baker, 1982), 549.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn59",
      "id": "rfn59"
    }
  }, [_vm._v("59")]), _vm._v(". Weiser, "), _c('i', [_vm._v("The Psalms")]), _vm._v(", 600f.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn60",
      "id": "rfn60"
    }
  }, [_vm._v("60")]), _vm._v(". GKC, 128s; "), _c('i', [_vm._v("IBHS")]), _vm._v(", §9.5.3a.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn61",
      "id": "rfn61"
    }
  }, [_vm._v("61")]), _vm._v(". Leland Ryken, James C. Wilhoit, and Tremper Longman III, eds., "), _c('i', [_vm._v("Dictionary of Biblical Imagery")]), _vm._v(" (Downers Grove, IL: IVP Academic, 1998), 865f.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn62",
      "id": "rfn62"
    }
  }, [_vm._v("62")]), _vm._v(". The smallest amount of time is called a "), _c('i', [_vm._v("rega"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(" (“moment,” cf. Exod. 33:5; Isa. 54:7–8; Jer. 4:20).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn63",
      "id": "rfn63"
    }
  }, [_vm._v("63")]), _vm._v(". Judg. 7:19 refers to a “middle watch” of the night (apparently of three); Lam. 2:19 refers to the beginning of the night watches; and Exod. 14:24 and 1 Sam. 11:11 mention “the morning watch,” which NIV interprets as the “last watch of the night.” Many verses of the Bible pair day and night to denote the entire twenty-four-hour period of a day, making night half of the daily cycle, or twelve hours. Accordingly a watch is 1/3 of 12 hours. “In the NT times division the Rom. division into four watches seems to have been used (cf. Mark 6:48)” (J. D. Douglas et al., eds., "), _c('i', [_vm._v("New Bible Dictionary")]), _vm._v(", 2nd ed. [Leicester: IVP, 1982], 1.242).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn64",
      "id": "rfn64"
    }
  }, [_vm._v("64")]), _vm._v(". Delitzsch, "), _c('i', [_vm._v("Psalms")]), _vm._v(", 52.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn65",
      "id": "rfn65"
    }
  }, [_vm._v("65")]), _vm._v(". Kirkpatrick, "), _c('i', [_vm._v("The Book of Psalms")]), _vm._v(", 550.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn66",
      "id": "rfn66"
    }
  }, [_vm._v("66")]), _vm._v(". The coming of sunrise, from the time when the stars that presage the new day are still visible (Job 38:7) and people and things are scarcely visible (Gen. 29:25; Ruth 3:14; 1 Kgs. 3:21) to the breaking of the sun over the horizon (Judg. 9:33; 2 Sam. 23:4; 2 Kgs. 3:22).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn67",
      "id": "rfn67"
    }
  }, [_vm._v("67")]), _vm._v(". M. D. Futato, "), _c('i', [_vm._v("NIDOTTE")]), _vm._v(", 2:247, s.v. "), _c('span', {
    staticClass: "charSI"
  }, [_c('i', [_vm._v("ḥāṣîr")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn68",
      "id": "rfn68"
    }
  }, [_vm._v("68")]), _vm._v(". The end of daylight (Gen. 1:5), a time when people stop work (Ruth 2:17; Ps. 104:23), gates are shut (Ezek. 46:2) and lamps are lit (Exod. 30:8) but people and objects are still visible (Gen. 24:63).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn69",
      "id": "rfn69"
    }
  }, [_vm._v("69")]), _vm._v(". For exceptions see “Author.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn70",
      "id": "rfn70"
    }
  }, [_vm._v("70")]), _vm._v(". Auffret, “Essai sur la structure,” 266f.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn71",
      "id": "rfn71"
    }
  }, [_vm._v("71")]), _vm._v(". "), _c('i', [_vm._v("IBHS")]), _vm._v(", §§30.5.c, d; cf. GKC, 106k, m.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn72",
      "id": "rfn72"
    }
  }, [_vm._v("72")]), _vm._v(". Kidner, "), _c('i', [_vm._v("Psalms 73–150")]), _vm._v(", 361.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn73",
      "id": "rfn73"
    }
  }, [_vm._v("73")]), _vm._v(". God’s anger was aroused against Moses’s generation when they complained about their hardships (Num. 11:1), complained about their restricted diet of manna (Num. 11:10), and worshiped the Baal of Peor (Num. 25:3–4).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn74",
      "id": "rfn74"
    }
  }, [_vm._v("74")]), _vm._v(". G. Sauer, "), _c('i', [_vm._v("TLOT")]), _vm._v(", 1:169, s.v. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v("ap")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn75",
      "id": "rfn75"
    }
  }, [_vm._v("75")]), _vm._v(". Ryken, Wilhoit, and Longman, "), _c('i', [_vm._v("Dictionary of Biblical Imagery,")]), _vm._v(" 26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn76",
      "id": "rfn76"
    }
  }, [_vm._v("76")]), _vm._v(". Tate ("), _c('i', [_vm._v("Psalms")]), _vm._v(", 434) thinks "), _c('i', [_vm._v("bhl")]), _vm._v(" Niphal may have its other sense, “to be in haste/hasty,” and if so means “being hurried (away to an untimely end).”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn77",
      "id": "rfn77"
    }
  }, [_vm._v("77")]), _vm._v(". BDB, p. 617, s.v. "), _c('i', [_vm._v("neged")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn78",
      "id": "rfn78"
    }
  }, [_vm._v("78")]), _vm._v(". C. S. Lewis, “The Weight of Glory,” in "), _c('i', [_vm._v("The Weight of Glory and Other Addresses")]), _vm._v(" (New York: Macmillan, 1949), 10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn79",
      "id": "rfn79"
    }
  }, [_vm._v("79")]), _vm._v(". J. A. Emerton, “Notes on Jer. 12:9,” "), _c('i', [_vm._v("ZAW")]), _vm._v(" 81 (1989): 189.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn80",
      "id": "rfn80"
    }
  }, [_vm._v("80")]), _vm._v(". Feuer, "), _c('i', [_vm._v("Tehillim,")]), _vm._v(" 4, 1.126. In its two other occurrences, it is used of the growling, rumbling sound of thunder (Job 37:2) and of “mourning” in the sequence of [words of] “lamentations and mourning/moaning and woe” (Ezek. 2:10).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn81",
      "id": "rfn81"
    }
  }, [_vm._v("81")]), _vm._v(". In the Bible, the span of human life begins with the astronomical longevity of the antediluvians (Gen. 5; Bruce K. Waltke with Cathi J. Fredericks, "), _c('i', [_vm._v("Genesis: A Commentary")]), _vm._v(" [Grand Rapids: Zondervan, 2001], 111) but goes through a logarithmic reduction of years after the flood, from 500 to 119 years (Gen. 11:10–25). The patriarchs, however, lived long: Abraham to 175, Isaac to 180, and Jacob to 147. Joseph lived to be 110, the ideal age of the Egyptians (J. Vergote, "), _c('i', [_vm._v("Joseph en Égypte")]), _vm._v(" [Louvain: Publications Universitaires, 1959], 200ff.; see "), _c('i', [_vm._v("ANET")]), _vm._v(", 414n33). Today few live to be 100, and were it not for modern medicine, the mortal could expect to live only 70 or 80 years. Sir. 18:9–10 resembles Ps. 90: “His [A human being’s] is at the most a hundred years; compared with unending time, his few years are like one drop from the ocean or a single grain of sand.” But the Talmud says that the average lifespan is sixty years: “Thus the man who reaches seventy has achieved . . . ‘ripe old age’ (Feuer, "), _c('i', [_vm._v("Tehillim")]), _vm._v(", 1.126).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn82",
      "id": "rfn82"
    }
  }, [_vm._v("82")]), _vm._v(". Heb. "), _c('i', [_vm._v("big"), _c('sup', [_vm._v("e")]), _vm._v("bûrōt.")]), _vm._v(" J. Kuelewein says the root "), _c('i', [_vm._v("gbr")]), _vm._v(" signifies “to be superior,” and “the basic meaning of "), _c('i', [_vm._v("g"), _c('sup', [_vm._v("e")]), _vm._v("bûrâ")]), _vm._v(", closely related to the verb, is “superiority, strength, might.” "), _c('i', [_vm._v("HALOT")]), _vm._v(" glosses it “in strength,” but adds “the strongest vitality” and cites Luther for the notion of “at the most.” Delitzsch ("), _c('i', [_vm._v("Psalms")]), _vm._v(", 598) cites with approval the same notion in Symmachus and the Talmud.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn83",
      "id": "rfn83"
    }
  }, [_vm._v("83")]), _vm._v(". Delitzsch ("), _c('i', [_vm._v("Psalms")]), _vm._v(", 598) identifies them as “riches, outward appearance, luxury, beauty, etc.”; cf. 1 John 2:16, "), _c('i', [_vm._v("hē alazoneia tou biou")]), _vm._v(" (“the boasting of life”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn84",
      "id": "rfn84"
    }
  }, [_vm._v("84")]), _vm._v(". "), _c('i', [_vm._v("HALOT")]), _vm._v(", 2:845, s.v. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("āmāl")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn85",
      "id": "rfn85"
    }
  }, [_vm._v("85")]), _vm._v(". S. Schwertner, "), _c('i', [_vm._v("TLOT,")]), _vm._v(" 2:925, s.v. "), _c('i', [_vm._v("‘āmāl")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn86",
      "id": "rfn86"
    }
  }, [_vm._v("86")]), _vm._v(". William Shakespeare, "), _c('i', [_vm._v("Julius Caesar")]), _vm._v(", 3.1.282–83.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn87",
      "id": "rfn87"
    }
  }, [_vm._v("87")]), _vm._v(". Weiser, "), _c('i', [_vm._v("The Psalms")]), _vm._v(", 600.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn88",
      "id": "rfn88"
    }
  }, [_vm._v("88")]), _vm._v(". Forster, "), _c('i', [_vm._v("Begrenztes leben,")]), _vm._v(" 150, quoted in Frank-Lothar Hossfeld and Erich Zenger, "), _c('i', [_vm._v("Commentary on Psalm 51-100")]), _vm._v(", trans. Linda M. Maloney, Hermeneia (Minneapolis: Fortress, 2005)"), _c('i', [_vm._v(",")]), _vm._v(" 420f.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn89",
      "id": "rfn89"
    }
  }, [_vm._v("89")]), _vm._v(". Hossfeld and Zenger, "), _c('i', [_vm._v("A Commentary on Psalms 51–100")]), _vm._v(", 418.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn90",
      "id": "rfn90"
    }
  }, [_vm._v("90")]), _vm._v(". James Crenshaw (“The Expression "), _c('i', [_vm._v("Mî Yôdēa"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(" in the Hebrew Bible,” "), _c('i', [_vm._v("VT")]), _vm._v(" 36, no. 3 [1986]: 274–88) divides the ten occurrences of "), _c('i', [_vm._v("mî-yôdēa"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")])]), _vm._v(" into two groups. “Five of them leave a door open to possible response that will change the situation for human good, and the other five (four in Eccl. plus Prov. 24:22) seem to assume a closed door.” He hesitantly includes Psalm 90:11 in the former; he cites no instance of a wish. His distinction, however, between “open” and “closed” seems arbitrary.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn91",
      "id": "rfn91"
    }
  }, [_vm._v("91")]), _vm._v(". A. S. van der Woude, "), _c('i', [_vm._v("TLOT,")]), _vm._v(" 2:870, s.v. "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("zz")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn92",
      "id": "rfn92"
    }
  }, [_vm._v("92")]), _vm._v(". See Bruce Waltke, “The Fear of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(",” in "), _c('i', [_vm._v("Alive to God: Studies in Spirituality,")]), _vm._v(" ed. J. I. Packer and Loren Wilkinson (Downers Grove, IL: InterVarsity, 1992), 17–33.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn93",
      "id": "rfn93"
    }
  }, [_vm._v("93")]), _vm._v(". Geoffrey W. Grogan, "), _c('i', [_vm._v("Psalms")]), _vm._v(" (Grand Rapids: Eerdmans, 2008), 159.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn94",
      "id": "rfn94"
    }
  }, [_vm._v("94")]), _vm._v(". John Goldingay, "), _c('i', [_vm._v("Psalms")]), _vm._v(", vol. 3, BCOTWP (Grand Rapids: Baker Academic, 2008), 31.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn95",
      "id": "rfn95"
    }
  }, [_vm._v("95")]), _vm._v(". "), _c('i', [_vm._v("IBHS")]), _vm._v(", §39.3.4e.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn96",
      "id": "rfn96"
    }
  }, [_vm._v("96")]), _vm._v(". Most English versions read “teach us,” but that translation obfuscates the connection with “know” in v. 11.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn97",
      "id": "rfn97"
    }
  }, [_vm._v("97")]), _vm._v(". Hossfeld and Zenger, "), _c('i', [_vm._v("A Commentary on Psalms 51–100")]), _vm._v(", 423.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn98",
      "id": "rfn98"
    }
  }, [_vm._v("98")]), _vm._v(". M. Wilcox, "), _c('i', [_vm._v("The Message of Psalm 73–150: Songs for the People of God")]), _vm._v(", The Bible Speaks Today (Leicester: InterVarsity Press, 2001), 77.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn99",
      "id": "rfn99"
    }
  }, [_vm._v("99")]), _vm._v(". Bruce K. Waltke, "), _c('i', [_vm._v("Proverbs 1–15")]), _vm._v(", NICOT (Grand Rapids: Eerdmans, 2004), 76–78; "), _c('i', [_vm._v("Finding the Will of God: A Pagan Notion")]), _vm._v(" (Grand Rapids: Eerdmans, 2016), 75f.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn100",
      "id": "rfn100"
    }
  }, [_vm._v("100")]), _vm._v(". Delitzsch, "), _c('i', [_vm._v("Psalms")]), _vm._v(", 599. Jeffrey D. Arthurs ("), _c('i', [_vm._v("Preaching as Reminding: Stirring Memory in an Age of Forgetfulness")]), _vm._v(" [Downers Grove, IL: InterVarsity Press, 2017], 23) tells of the burial practices of the Trappist monks: “When one of the brothers of the monastery dies, they place his body in a newly dug grave, and immediately after the interment they trace the dimensions of a new grave, the resting place of the next brother who will die.” Arthurs teaches: “In this way they remind themselves of their own mortality and thus gain wisdom for living.” On the day I (Bruce) prepared a sermon on this psalm in 1967, the total number of days to my seventieth birthday were 12,345—I could scarcely believe the sequence. Of course, the sum changes daily. When I told my wife I would daily subtract one from the remaining sum for the rest of my life, she replied “That’s morbid.” I did it for years to my spiritual benefit, and since passing that mark I still keep track.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn101",
      "id": "rfn101"
    }
  }, [_vm._v("101")]), _vm._v(". Weiser, "), _c('i', [_vm._v("The Psalms")]), _vm._v(", 602.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn102",
      "id": "rfn102"
    }
  }, [_vm._v("102")]), _vm._v(". Tate, "), _c('i', [_vm._v("Psalms 51–100")]), _vm._v(", 437.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn103",
      "id": "rfn103"
    }
  }, [_vm._v("103")]), _vm._v(". Kirkpatrick, "), _c('i', [_vm._v("The Book of Psalms,")]), _vm._v(" 55.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn104",
      "id": "rfn104"
    }
  }, [_vm._v("104")]), _vm._v(". Isaac Taylor quoted in J. J. Stewart Perowne, "), _c('i', [_vm._v("The Book of Psalms")]), _vm._v(", vol. 2 (Andover: Warren F. Draper, 1898), 157.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn105",
      "id": "rfn105"
    }
  }, [_vm._v("105")]), _vm._v(". Owing to the excitement and complaining exclamation, the poet suppresses the indispensable subject and predicate (GKC, 147c).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn106",
      "id": "rfn106"
    }
  }, [_vm._v("106")]), _vm._v(". "), _c('i', [_vm._v("HALOT")]), _vm._v(", 1:248, s.v. "), _c('i', [_vm._v("rānan")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn107",
      "id": "rfn107"
    }
  }, [_vm._v("107")]), _vm._v(". Rabbi Avrohom Chaim Feuer, "), _c('i', [_vm._v("Tehillim: A New Translaton with a Commentary Anthologized from Talmudic, Midrashic, and Rabbinic Sources")]), _vm._v(" (Brooklyn: Mesorah Publications, 1985), 1129.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn108",
      "id": "rfn108"
    }
  }, [_vm._v("108")]), _vm._v(". III "), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("ānâ")]), _vm._v(" Piel occurs fifty-four times and at the least means the use of force to alter the status of someone for the worse. Birkeland ("), _c('i', [_vm._v("TDOT")]), _vm._v(", 11:237, s.v. "), _c('i', [_vm._v("‘ānâ")]), _vm._v(" II) says of its uses: “A person who ‘oppresses, violates, abuses, humiliates’ is using power contrary to the demands of justice.” But this is certainly not true of its use with God as the agent. The psalmist says: “I know, "), _c('i', [_vm._v("I AM")]), _vm._v(", that your laws are righteous, and that in faithfulness you have afflicted me ["), _c('i', [_c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("innîtānî")]), _vm._v("]” (Ps. 119:75). Similarly, “he [God] is not predisposed to afflict ["), _c('i', [_vm._v("lō"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʾ")]), _vm._v(" "), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("innâ millibbô")]), _vm._v("] or grieve people” (Lam. 3:33, NET). God afflicted Israel in the wilderness with hunger not as punishment but as a test of faith, since hunger was not part of his covenant design (Deut. 8:2–3). Otherwise “he afflicts” is used commonly of his punishment for sin (Isa. 64:12[11]; Nah 1:12), though it is used of waves overwhelming the psalmist without a stated reason in Ps. 88:7[8].")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn109",
      "id": "rfn109"
    }
  }, [_vm._v("109")]), _vm._v(". “See” commonly signifies “to experience something” (Pss. 16:10; 89:48[49]; Eccl. 5:18[17]; passim).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn110",
      "id": "rfn110"
    }
  }, [_vm._v("110")]), _vm._v(". The feminine abstract noun "), _c('i', [_vm._v("rā"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("â")]), _vm._v(" (“disaster”) denotes the evaluation that something is bad, whether it be a concrete physical state (e.g. “ugly” cows, Gen. 41:3; “poor/bad” figs, Jer. 24), an abstraction of moral behavior that injures others, or a physical “disaster, calamity, trouble.” The parallel “afflicts” shows it refers to “calamity/disaster.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn111",
      "id": "rfn111"
    }
  }, [_vm._v("111")]), _vm._v(". Feuer ("), _c('i', [_vm._v("Tehillim")]), _vm._v(", 1130) comments: “A great many opinions are offered by the "), _c('i', [_vm._v("Talmud")]), _vm._v(" ("), _c('i', [_vm._v("Sanhedrin")]), _vm._v(" 99a) to determine the duration of the Messianic era. Some say that it will last forty years corresponding to the number of years the Jews suffered in the wilderness, . . . or 400 years corresponding to the years of Egyptian bondage, . . . or 7000 years like the days of the week, and each day of God is 1000 years (see v. 4).” Many Christians, like the rabbis, interpret eschatological texts woodenly. According to them, the messianic era will last 1,000 years (see Rev 20:6).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn112",
      "id": "rfn112"
    }
  }, [_vm._v("112")]), _vm._v(". Kirkpatrick, "), _c('i', [_vm._v("The Book of Psalms,")]), _vm._v(" 552.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn113",
      "id": "rfn113"
    }
  }, [_vm._v("113")]), _vm._v(". Amos "), _c('span', {
    staticClass: "charSR"
  }, [_vm._v("Ḥakham")]), _vm._v(", "), _c('i', [_vm._v("Psalms with the Jerusalem Commentary")]), _vm._v(", trans. Israel V. Berman, vol. 2 (Jerusalem: Mosad Harav Kook, 2003), 357.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn114",
      "id": "rfn114"
    }
  }, [_vm._v("114")]), _vm._v(". BDB, p. 821, s.v. "), _c('i', [_vm._v("pō"), _c('span', {
    staticClass: "charSI"
  }, [_vm._v("ʿ")]), _vm._v("al")]), _vm._v(", §1a.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn115",
      "id": "rfn115"
    }
  }, [_vm._v("115")]), _vm._v(". Samuel A. Meier, "), _c('i', [_vm._v("NIDOTTE")]), _vm._v(", 3:122, s.v. "), _c('i', [_vm._v("n‘m")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn116",
      "id": "rfn116"
    }
  }, [_vm._v("116")]), _vm._v(". Feuer ("), _c('i', [_vm._v("Tehillim")]), _vm._v(", 1131) comments: “The children of Israel responded to Moses’ blessing (Exod. 39:43) by affirming Moses’ blessing, saying, "), _c('i', [_vm._v("May the pleasantness of my")]), _vm._v(" [sic] "), _c('i', [_vm._v("Lord, our God, be upon us")]), _vm._v(" ("), _c('i', [_vm._v("Sifri, Pinchos")]), _vm._v(" 28:8).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn117",
      "id": "rfn117"
    }
  }, [_vm._v("117")]), _vm._v(". "), _c('i', [_vm._v("IBHS")]), _vm._v(", §9.5.1h.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn118",
      "id": "rfn118"
    }
  }, [_vm._v("118")]), _vm._v(". Koch, "), _c('i', [_vm._v("TDOT")]), _vm._v(", 7:97, s.v. "), _c('i', [_vm._v("kûn")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn119",
      "id": "rfn119"
    }
  }, [_vm._v("119")]), _vm._v(". "), _c('span', {
    staticClass: "charSR"
  }, [_vm._v("Ḥakham")]), _vm._v(", "), _c('i', [_vm._v("Psalms 58–100")]), _vm._v(", 356.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn120",
      "id": "rfn120"
    }
  }, [_vm._v("120")]), _vm._v(". Weiser, "), _c('i', [_vm._v("The Psalms")]), _vm._v(", 603.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn121",
      "id": "rfn121"
    }
  }, [_vm._v("121")]), _vm._v(". Goldingay, "), _c('i', [_vm._v("Psalms")]), _vm._v(", 23; J. Clinton McCann, Jr., "), _c('i', [_vm._v("Psalms")]), _vm._v(", NIB 4 (Nashville: Abingdon, 1996), 1040.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn122",
      "id": "rfn122"
    }
  }, [_vm._v("122")]), _vm._v(". Susan Gillingham, "), _c('i', [_vm._v("Psalms through the Centuries,")]), _vm._v(" vol. 1 (Oxford: Blackwell, 2008), 40, 44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn123",
      "id": "rfn123"
    }
  }, [_vm._v("123")]), _vm._v(". David M. Gwynn, "), _c('i', [_vm._v("Athansius of Alexandria: Bishop, Theologian, Ascetic, Father")]), _vm._v(" (Oxford: Oxford University Press, 2012), 149.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn124",
      "id": "rfn124"
    }
  }, [_vm._v("124")]), _vm._v(". Athanasius, "), _c('i', [_vm._v("Ep. Marcell.")]), _vm._v(" 27, in "), _c('i', [_vm._v("Athanasius: The Life of Antony and the Letter to Marcellinus")]), _vm._v(", trans. Robert C. Gregg (Mahwah, NJ; Paulist, 1980), 124.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn125",
      "id": "rfn125"
    }
  }, [_vm._v("125")]), _vm._v(". Carol Harrison, “Enchanting the Soul: The Music of the Psalms,” in "), _c('i', [_vm._v("Meditations of the Heart: The Psalms in Early Christian Thought and Practice,")]), _vm._v(" ed. A. G. Andreopoulos, Augustine Cassidy, and Carol Harrison (Louvain: Brepols, 2011), 211.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn126",
      "id": "rfn126"
    }
  }, [_vm._v("126")]), _vm._v(". Athanasius, "), _c('i', [_vm._v("Ep. Marcell.")]), _vm._v(" 22 (Gregg, 120).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn127",
      "id": "rfn127"
    }
  }, [_vm._v("127")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Exposition of Psalm 89")]), _vm._v(" 2 in "), _c('i', [_vm._v("Expositions on the Psalms,")]), _vm._v(" trans. Maria Boulding, vol. 4 (Hyde Park, NY: New City, 2002), 303.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn128",
      "id": "rfn128"
    }
  }, [_vm._v("128")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Exposition of Psalm 89")]), _vm._v(" 2 (Boulding, 303).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn129",
      "id": "rfn129"
    }
  }, [_vm._v("129")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Exposition of Psalm 89")]), _vm._v(" 3 (Boulding, 304f.).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn130",
      "id": "rfn130"
    }
  }, [_vm._v("130")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Exposition of Psalm 89")]), _vm._v(" 10 (Boulding, 308).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn131",
      "id": "rfn131"
    }
  }, [_vm._v("131")]), _vm._v(". Augustine, "), _c('i', [_vm._v("Exposition of Psalm 89")]), _vm._v(" 17 (Boulding, 313–14).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn132",
      "id": "rfn132"
    }
  }, [_vm._v("132")]), _vm._v(". Hans Boersma, "), _c('i', [_vm._v("Scripture as Real Presence: Sacramental Exegesis in the Early Church")]), _vm._v(" (Grand Rapids: Baker Academic, 2017), 143.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn133",
      "id": "rfn133"
    }
  }, [_vm._v("133")]), _vm._v(". Boersma, "), _c('i', [_vm._v("Scripture as Real Presence")]), _vm._v(", 154–56.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn134",
      "id": "rfn134"
    }
  }, [_vm._v("134")]), _vm._v(". Boersma, "), _c('i', [_vm._v("Scripture as Real Presence")]), _vm._v(", 158.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn135",
      "id": "rfn135"
    }
  }, [_vm._v("135")]), _vm._v(". Dennis Ngien, "), _c('i', [_vm._v("Fruit for the Soul: Luther on the Lament Psalms")]), _vm._v(" (Minneapolis: Fortress, 2015), 157.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn136",
      "id": "rfn136"
    }
  }, [_vm._v("136")]), _vm._v(". Ngien, "), _c('i', [_vm._v("Fruit for the Soul")]), _vm._v(", 158.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn137",
      "id": "rfn137"
    }
  }, [_vm._v("137")]), _vm._v(". Ngien, "), _c('i', [_vm._v("Fruit for the Soul")]), _vm._v(", 159.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn138",
      "id": "rfn138"
    }
  }, [_vm._v("138")]), _vm._v(". Ngien, "), _c('i', [_vm._v("Fruit for the Soul")]), _vm._v(", 169.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn139",
      "id": "rfn139"
    }
  }, [_vm._v("139")]), _vm._v(". Martin Luther, “Psalm 90,” trans. Paul M. Bretscher, "), _c('i', [_vm._v("Luther’s Works")]), _vm._v(" (Minneapolis: Fortress, 1956) 13:128–29, quoted in Ngien, "), _c('i', [_vm._v("Fruit for the Soul")]), _vm._v(", 171.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn140",
      "id": "rfn140"
    }
  }, [_vm._v("140")]), _vm._v(". Ngien, "), _c('i', [_vm._v("Fruit for the Soul")]), _vm._v(", 183.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn141",
      "id": "rfn141"
    }
  }, [_vm._v("141")]), _vm._v(". Gerhard O. Forde, "), _c('i', [_vm._v("Where God Meets Man: Luther’s Down-to-Earth Approach to the Gospel")]), _vm._v(" (Minneapolis: Augsburg, 1972), 26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn142",
      "id": "rfn142"
    }
  }, [_vm._v("142")]), _vm._v(". Bruce K. Waltke and James M. Houston with Erika Moore, "), _c('i', [_vm._v("The Psalms as Christian Worship: A Historical Commentary")]), _vm._v(" (Grand Rapids: Eerdmans, 2010), 450.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn143",
      "id": "rfn143"
    }
  }, [_vm._v("143")]), _vm._v(". Ngien, "), _c('i', [_vm._v("Fruit for the Soul")]), _vm._v(", 190–95.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn144",
      "id": "rfn144"
    }
  }, [_vm._v("144")]), _vm._v(". Ngien, "), _c('i', [_vm._v("Fruit for the Soul")]), _vm._v(", 195–96.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn145",
      "id": "rfn145"
    }
  }, [_vm._v("145")]), _vm._v(". Gerald H. Wilson, "), _c('i', [_vm._v("The Editing of the Hebrew Psalter")]), _vm._v(", SBLDS 76 (Chico, CA: Scholars, 1985)"), _c('i', [_vm._v(",")]), _vm._v(" 209–28.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn146",
      "id": "rfn146"
    }
  }, [_vm._v("146")]), _vm._v(". Harry Nasuti, "), _c('i', [_vm._v("Defining the Sacred Songs: Genre, Tradition, and the Post-Critical Intepretation of the Psalms")]), _vm._v(", JSOTSup 218 (Sheffield: Sheffield Academic, 1999), 177.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn147",
      "id": "rfn147"
    }
  }, [_vm._v("147")]), _vm._v(". McCann, "), _c('i', [_vm._v("Psalms")]), _vm._v(", 1040.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81d967f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter002.vue
// module id = 72
// module chunks = 0